/* eslint-disable static-service/require-nltext-is-translated */
import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import Link from "@khanacademy/wonder-blocks-link";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries, standardTransition} from "@repo/shared-styles";
import {cssUrl} from "@repo/urls";

import PageRoot from "#app-shell-package/page-root.tsx";
import * as hacks from "#shared-styles-package/hacks.ts";

import caretDownIcon from "@phosphor-icons/core/bold/caret-down-bold.svg";

type Props = Record<any, any>;
type State = {
    learnMoreOpen: any;
    learnMoreIsExpanded: boolean;
};

// We need either isMobile or isDesktop to be true at the same time. In Chrome,
// at non-standard zoom levels (e.g., 110%), [isMobile, isDesktop] =
// media.screen.breakAtWidth results in isMobile and isDesktop not being
// opposites.
export const isMobile: any = "@media screen and (max-width: 1023px)";
export const isDesktop: any = "@media screen and (min-width: 1023.5px)";

export default class SpanishPrivacyPolicyPage extends React.Component<
    Props,
    State
> {
    state: State = {
        learnMoreOpen: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        learnMoreIsExpanded: false,
    };

    // By default, non-expanded content cannot be found by browser search.
    // If a user is trying to search the page, we want to expand all
    // the content so the whole page is searchable. Here, we listen
    // for Ctrl/⌘+F and expand all content when pressed.
    componentDidMount() {
        document.body?.classList.toggle("listen-for-search");
        window.addEventListener("keydown", this.handleWindowKeyDown, false);
    }

    componentWillUnmount() {
        document.body?.classList.remove("listen-for-search");
        window.removeEventListener("keydown", this.handleWindowKeyDown, false);
    }

    handleWindowKeyDown: (e?: any) => void = (e) => {
        if (e.which === 70 && (e.ctrlKey || e.metaKey)) {
            this.expandAll(true);
        }
    };

    toggleLearnMore(index: any) {
        const newList = this.state.learnMoreOpen;
        newList[index] = !newList[index];
        this.setState({learnMoreOpen: newList});
    }

    expandAll(bool: boolean) {
        const newList = new Array(this.state.learnMoreOpen.length).fill(bool);
        this.setState({learnMoreOpen: newList, learnMoreIsExpanded: bool});
    }

    // TODO: (cat) change table header elements to be more
    // accessible to screen reader
    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`Aviso de Privacidad`}}>
                <div className={css(styles.wrapper)}>
                    <div className={css(styles.header)}>
                        <div className={css(styles.headerCopy)}>
                            <h1 className={css(styles.pageTitle)}>
                                Aviso de Privacidad de Khan Academy
                            </h1>
                            <p className={css(styles.lastUpdated)}>
                                Última actualización: Noviembre 1, 2024
                            </p>
                        </div>
                    </div>
                    <div className={css(styles.body)}>
                        <div className={css(styles.columns)}>
                            <div className={css(styles.stickyTOC)}>
                                <nav
                                    className={css(
                                        styles.tableOfContentsColumn,
                                    )}
                                >
                                    <h2 className={css(styles.tocTitle)}>
                                        <strong>Índice</strong>
                                    </h2>
                                    <ul
                                        className={css(
                                            styles.tableOfContentList,
                                        )}
                                    >
                                        <li>
                                            <Link href="#privacy-principles">
                                                Principios de Privacidad de Khan
                                                Academy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#overview">
                                                Descripción general
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#contact">
                                                Contacto con Khan Academy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#collection-info">
                                                Recopilación de información
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#use-of-info">
                                                Uso de los datos
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#sharing">
                                                Divulgación de datos
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#retention">
                                                Retención de Datos Personales
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#advertising">
                                                Patrocinio y publicidad
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#transparency">
                                                Transparencia y sus elecciones
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#settings">
                                                Configuración de su cuenta
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#security">
                                                Seguridad de sus datos
                                                personales
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#third-parties">
                                                Enlaces a terceros
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#changes">
                                                Cambios a este Aviso de
                                                Privacidad
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#additional-privacy">
                                                Avisos de Privacidad adicionales
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#schools">
                                                Uso por Parte de las Escuelas y
                                                los Estudiantes
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#childrens-privacy">
                                                Aviso de privacidad de menores
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#donor-info">
                                                Información de donadores
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#paid-products">
                                                Productos de Pago
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#applicant">
                                                Información del solicitante
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#regional-info">
                                                Información regional
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div className={css(styles.contentColumn)}>
                                <p className={css(styles.paragraph)}>
                                    <em>
                                        NOTA: Este documento es una traducción
                                        del idioma inglés, y ha sido elaborado
                                        para la comodidad del lector. La versión
                                        en idioma inglés de este documento es el
                                        instrumento original, el que rige y la
                                        única versión que vincula a las partes.
                                        En caso de conflicto entre esta versión
                                        traducida y la versión original en
                                        inglés, prevalecerá la versión en inglés
                                        (que está disponible en
                                        www.khanacademy.org).
                                    </em>
                                </p>
                                <h2
                                    id="privacy-principles"
                                    className={css(styles.sectionTitle)}
                                >
                                    Principios de Privacidad de Khan Academy
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    <strong>
                                        Nuestro Aviso de Privacidad se basa en
                                        nuestro compromiso con estos Principios
                                        de Privacidad:
                                    </strong>
                                </p>
                                <ol className={css(styles.orderedList)}>
                                    <li>
                                        Estamos profundamente comprometidos con
                                        la creación de un entorno en línea
                                        seguro para usted.
                                    </li>
                                    <li>
                                        No vendemos sus datos personales a
                                        terceros. Establecimos Khan Academy como
                                        una organización sin fines de lucro para
                                        que nuestra misión de educación y su
                                        confianza no entren en conflicto con un
                                        motivo de lucro.
                                    </li>
                                    <li>
                                        Nos esforzamos por brindarle acceso y
                                        control sobre la información que nos
                                        brinda, y nos tomamos muy en serio la
                                        protección de sus datos.
                                    </li>
                                    <li>
                                        Tomamos precauciones adicionales para
                                        nuestros estudiantes más jóvenes como se
                                        describe en nuestro{" "}
                                        <Link
                                            href="#childrens-privacy"
                                            inline={true}
                                        >
                                            Aviso de Privacidad de Menores
                                        </Link>
                                        , incluida la restricción de las cuentas
                                        de menores para bloquear automáticamente
                                        las funciones que permitirían que un
                                        niño publique o divulgue datos
                                        personales.
                                    </li>
                                    <li>
                                        No mostramos publicidad de terceros en
                                        Khan Academy. Nuestra misión es
                                        brindarle una educación de clase
                                        mundial, no venderle productos.
                                    </li>
                                </ol>
                                <h2
                                    id="overview"
                                    className={css(styles.sectionTitle)}
                                >
                                    Descripci&oacute;n general
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy, Inc. (“
                                    <strong>Khan Academy</strong>”, “
                                    <strong>nuestros</strong>”, “
                                    <strong>nos</strong>”, o “
                                    <strong>nosotros</strong>”) es una
                                    organización benéfica sin fines de lucro con
                                    sede en EE. UU. Como organización sin fines
                                    de lucro 501 (c) (3), utilizamos la
                                    información que recopilamos para brindarle
                                    una mejor experiencia y cumplir con nuestra
                                    misión de brindar una educación gratuita de
                                    clase mundial para cualquier persona, en
                                    cualquier lugar. Nos establecimos como una
                                    organización sin fines de lucro para que un
                                    motivo con fines de lucro no interfiera con
                                    nuestra misión de proporcionar un recurso
                                    educativo confiable.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Estamos comprometidos a proteger su
                                    privacidad. Entendemos lo importante que es
                                    la privacidad para usted y estamos
                                    comprometidos a proteger su privacidad y a
                                    crear un entorno más seguro para estudiantes
                                    de todas las edades. Este Aviso de
                                    Privacidad explica cómo la información es
                                    recopilada, utilizada, divulgada y protegida
                                    por Khan Academy cuando usted usa (o accede)
                                    a nuestro sitio web en www.khanacademy.org,
                                    nuestra aplicación móvil y servicio en línea
                                    (colectivamente, nuestro “
                                    <strong>Servicio</strong>”). Nuestra
                                    aplicación móvil Khan Academy Kids se rige
                                    por un{" "}
                                    <Link
                                        inline={true}
                                        target="_blank"
                                        href="/kids/privacy-policy"
                                    >
                                        Aviso de Privacidad diferente de Khan
                                        Academy Kids
                                    </Link>
                                    .
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Nota: Para cada sección de este Aviso de
                                    Privacidad, puede ver las prácticas
                                    generales de privacidad al comienzo de la
                                    sección y ver más información revisando "Más
                                    información" para la sección
                                    correspondiente.
                                </p>
                                <h3 className={css(styles.sectionSubtitle)}>
                                    Uso por Niños y Estudiantes
                                </h3>
                                <p className={css(styles.paragraph)}>
                                    Para obtener información específica sobre
                                    cómo recopilamos, usamos y tratamos los
                                    datos personales cuando brindamos el
                                    Servicio a escuelas, distritos escolares y
                                    maestros, revise la sección de{" "}
                                    <Link href="#schools" inline={true}>
                                        Uso por Parte de las Escuelas y los
                                        Estudiantes
                                    </Link>
                                    .
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Nuestro{" "}
                                    <Link
                                        inline={true}
                                        href="#childrens-privacy"
                                    >
                                        Aviso de Privacidad de Menores
                                    </Link>{" "}
                                    describe cómo recopilamos, usamos y tratamos
                                    los datos personales de menores de 13 años.
                                </p>
                                <h2
                                    id="contact"
                                    className={css(styles.sectionTitle)}
                                >
                                    Contacto con Khan Academy
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Póngase en contacto con Khan Academy si
                                    tiene alguna pregunta o comentario.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Por correo electrónico:{" "}
                                    <Link
                                        inline={true}
                                        href="mailto:privacy@khanacademy.org"
                                    >
                                        nuestro Equipo de Privacidad
                                    </Link>
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Por correo: Khan Academy, PO Box 1630,
                                    Mountain View, CA 94042
                                </p>
                                <p className={css(styles.paragraph)}>
                                    También puede visitar el Centro de
                                    Asistencia de la página{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="https://khanacademy.zendesk.com/hc/es"
                                    >
                                        Centro de Asistencia de Khan Academy
                                    </Link>{" "}
                                    y{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="https://khanacademy.zendesk.com/hc/categories/200175860-Common-Questions"
                                    >
                                        Preguntas Comunes y Recursos
                                    </Link>
                                    , que alberga preguntas frecuentes e
                                    información útil que puede encontrar.
                                </p>

                                <h2
                                    id="collection-info"
                                    className={css(styles.sectionTitle)}
                                >
                                    Recolección de Información
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Recopilamos información de las siguientes
                                    maneras, según su uso del Servicio y la
                                    configuración de su cuenta:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Recopilamos información de usted
                                        directamente, como cuando crea una
                                        cuenta, se comunica con nosotros,
                                        participa en actividades, eventos o
                                        encuestas, o proporciona información
                                        durante el uso del Servicio.
                                    </li>
                                    <li>
                                        Podemos recopilar información de otros,
                                        como su padre, maestro o escuela, o de
                                        terceros (es decir, organizaciones fuera
                                        de Khan Academy), como aplicaciones de
                                        terceros que utiliza para conectarse al
                                        Servicio.
                                    </li>
                                    <li>
                                        Recopilamos cierta información
                                        automáticamente, como información sobre
                                        su uso del Servicio y los dispositivos
                                        que usa para acceder al Servicio.
                                        Podemos utilizar cookies, balizas web y
                                        tecnologías similares para recopilar
                                        información como se explica en nuestro{" "}
                                        <Link
                                            target="_blank"
                                            inline={true}
                                            href="/about/cookie-policy"
                                        >
                                            Aviso de Cookies
                                        </Link>
                                        .
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Algunos ejemplos de datos que podemos
                                    recopilar incluyen:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Información de registro de la cuenta
                                        (nombre de usuario, fecha de nacimiento
                                        y correo electrónico)
                                    </li>
                                    <li>
                                        Información sobre su navegador o
                                        dispositivo y ubicación general
                                    </li>
                                    <li>
                                        Información que elige incluir en su
                                        perfil o publicar en áreas públicas del
                                        Servicio.
                                    </li>
                                    <li>
                                        Información que puede proporcionar en
                                        relación con funciones específicas o
                                        programas especiales
                                    </li>
                                    <li>
                                        Datos no personales que puede estar
                                        vinculada a sus datos personales,
                                        incluida la información sobre su uso de
                                        nuestro Servicio.
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Se proporciona información adicional sobre
                                    nuestra recopilación de datos de menores y
                                    estudiantes en nuestro{" "}
                                    <Link
                                        inline={true}
                                        href="#childrens-privacy"
                                    >
                                        Aviso de Privacidad de Menores
                                    </Link>{" "}
                                    y{" "}
                                    <Link inline={true} href="#schools">
                                        Uso por Parte de las Escuelas y los
                                        Estudiantes
                                    </Link>
                                    . Se proporciona más información sobre cómo
                                    Khan Academy recopila sus datos en “Más
                                    información”.
                                </p>
                                <button
                                    type="button"
                                    className={css(styles.expandAll)}
                                    onClick={() =>
                                        this.expandAll(
                                            !this.state.learnMoreIsExpanded,
                                        )
                                    }
                                >
                                    {this.state.learnMoreIsExpanded
                                        ? "Contraer Todas las Secciones"
                                        : "Expandir Todas las Secciones"}
                                </button>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(0)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[0]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[0] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Información que nos
                                                            proporciona
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Información de
                                                                contacto y
                                                                perfil.
                                                            </strong>{" "}
                                                            Cuando crea una
                                                            cuenta en el
                                                            Servicio de Khan
                                                            Academy, podemos
                                                            recopilar
                                                            información,
                                                            incluido su nombre,
                                                            dirección de correo
                                                            electrónico, fecha
                                                            de nacimiento y
                                                            datos de edad (para
                                                            fines de
                                                            cumplimiento).
                                                            También recopilamos
                                                            información de
                                                            inicio de sesión,
                                                            incluido el nombre
                                                            de usuario y la
                                                            contraseña. Después
                                                            de registrarse,
                                                            también puede optar
                                                            por proporcionar
                                                            información
                                                            adicional en su
                                                            perfil, como su
                                                            apodo y otros datos
                                                            personales o
                                                            demográfica.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Sus
                                                                comunicaciones
                                                                con nosotros.
                                                            </strong>{" "}
                                                            Podemos recopilar
                                                            información sobre
                                                            usted en otros
                                                            momentos, como
                                                            cuando solicita
                                                            atención al cliente,
                                                            nos envía un correo
                                                            electrónico, publica
                                                            un comentario o
                                                            pregunta,
                                                            proporciona
                                                            retroalimentación,
                                                            completa una
                                                            encuesta de usuario,
                                                            participa en un
                                                            programa especial o
                                                            se comunica de otra
                                                            manera con Khan
                                                            Academy (incluso a
                                                            través de servicios
                                                            de terceros).
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Su interacción
                                                                con nuestros
                                                                Servicios.
                                                            </strong>{" "}
                                                            Podemos recopilar
                                                            información sobre
                                                            usted cuando
                                                            interactúa con
                                                            funciones de los
                                                            Servicios, como
                                                            nuestro chatbot
                                                            basado en
                                                            Inteligencia
                                                            Artificial (IA),
                                                            Khanmigo.
                                                        </li>
                                                    </ul>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Información que
                                                            podemos recibir de
                                                            otras personas sobre
                                                            usted
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Información
                                                                obtenida de una
                                                                escuela o de
                                                                otros usuarios.
                                                            </strong>{" "}
                                                            Ponemos a
                                                            disposición ciertas
                                                            funciones en nuestro
                                                            Servicio que
                                                            permiten a otros
                                                            usuarios
                                                            proporcionarnos
                                                            información sobre
                                                            usted. Por ejemplo,
                                                            una escuela o un
                                                            maestro puede
                                                            proporcionar
                                                            información
                                                            relacionada con los
                                                            participantes en una
                                                            clase, o un padre
                                                            puede proporcionar
                                                            información
                                                            relacionada con un
                                                            Usuario de menores,
                                                            como cuando un padre
                                                            registra una cuenta
                                                            para su Hijo y nos
                                                            proporciona cierta
                                                            información sobre el
                                                            Niño, (como el
                                                            nombre de usuario y
                                                            la edad). Por favor,
                                                            revise nuestro{" "}
                                                            <Link
                                                                inline={true}
                                                                href="#childrens-privacy"
                                                            >
                                                                Aviso de
                                                                Privacidad de
                                                                Menores
                                                            </Link>{" "}
                                                            y{" "}
                                                            <Link
                                                                inline={true}
                                                                href="#schools"
                                                            >
                                                                Uso por Parte de
                                                                las Escuelas y
                                                                los Estudiantes
                                                            </Link>
                                                            para obtener
                                                            información
                                                            adicional sobre el
                                                            uso de nuestro
                                                            Servicio por parte
                                                            de menores y
                                                            estudiantes.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información de
                                                                los servicios de
                                                                autenticación de
                                                                Inicio de Sesión
                                                                Único (SSO, por
                                                                sus siglas en
                                                                inglés).
                                                            </strong>{" "}
                                                            Si decide
                                                            registrarse para
                                                            obtener una cuenta
                                                            (o acceder a su
                                                            cuenta) a través de
                                                            un servicio de
                                                            autenticación (como
                                                            Cuentas de Google o
                                                            Clever como un
                                                            Inicio de Sesión
                                                            Único, también
                                                            conocido como SSO)
                                                            (“
                                                            <strong>
                                                                Servicio de
                                                                Autenticación
                                                            </strong>
                                                            ”), podemos
                                                            recopilar
                                                            información de estos
                                                            servicios de
                                                            terceros, de acuerdo
                                                            con su configuración
                                                            de privacidad en su
                                                            cuenta con el
                                                            Servicio de
                                                            Autenticación
                                                            correspondiente.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información que
                                                                recopilamos para
                                                                permitir su
                                                                participación en
                                                                programas o
                                                                funciones
                                                                especiales.
                                                            </strong>{" "}
                                                            Khan Academy puede
                                                            presentar un
                                                            programa o actividad
                                                            especial que
                                                            ofrecemos en
                                                            asociación con un
                                                            tercero. Si
                                                            participa en estos
                                                            programas
                                                            especiales, Khan
                                                            Academy puede
                                                            recopilar
                                                            información suya
                                                            para facilitar esos
                                                            programas.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información
                                                                proporcionada
                                                                por socios y
                                                                otras fuentes.
                                                            </strong>{" "}
                                                            También podemos
                                                            recibir información
                                                            de organizaciones
                                                            externas con las que
                                                            nos asociamos para
                                                            brindar servicios
                                                            educativos. Si
                                                            asociamos
                                                            información de otras
                                                            fuentes con datos
                                                            personales que
                                                            recopilamos a través
                                                            de nuestro Servicio,
                                                            trataremos la
                                                            información
                                                            combinada como datos
                                                            personales de
                                                            acuerdo con este
                                                            Aviso de Privacidad.
                                                        </li>
                                                    </ul>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Información que
                                                            recopilamos
                                                            automáticamente
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Información
                                                                sobre su uso de
                                                                nuestro
                                                                Servicio.
                                                            </strong>{" "}
                                                            Podemos recopilar
                                                            información de uso
                                                            sobre su uso de
                                                            nuestro Servicio,
                                                            como el número de
                                                            problemas que ha
                                                            intentado, la
                                                            cantidad de videos
                                                            que ha visto, los
                                                            tipos de ejercicios
                                                            que has realizado,
                                                            las materias
                                                            estudiadas, la
                                                            cantidad de tiempo
                                                            dedicado a completar
                                                            un problema y datos
                                                            relacionados con las
                                                            conversaciones y
                                                            actividades de
                                                            Khanmigo. Esto nos
                                                            permite adaptar
                                                            mejor las
                                                            experiencias
                                                            educativas que sean
                                                            más apropiadas para
                                                            usted.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información de
                                                                ubicación.
                                                            </strong>{" "}
                                                            Podemos recopilar y
                                                            usar información
                                                            sobre su ubicación
                                                            (como su país) o
                                                            inferir su ubicación
                                                            aproximada en
                                                            función de su
                                                            dirección IP para
                                                            brindarle
                                                            experiencias
                                                            educativas
                                                            personalizadas para
                                                            su región, pero no
                                                            recopilamos datos de
                                                            geolocalización
                                                            precisos. Es posible
                                                            que pueda cambiar la
                                                            configuración en su
                                                            computadora o
                                                            dispositivo móvil
                                                            para evitar que nos
                                                            brinde datos de
                                                            ubicación.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información de
                                                                uso y del
                                                                dispositivo.
                                                            </strong>{" "}
                                                            Para proporcionar un
                                                            aprendizaje
                                                            personalizado y una
                                                            experiencia de alta
                                                            calidad para
                                                            nuestros usuarios,
                                                            podemos utilizar
                                                            varias tecnologías
                                                            que registran
                                                            automáticamente
                                                            cierta información
                                                            técnica de su
                                                            navegador o
                                                            dispositivo cuando
                                                            visita nuestro sitio
                                                            web, lea nuestros
                                                            correos
                                                            electrónicos,
                                                            utilice nuestro
                                                            Servicio o
                                                            comprométase de
                                                            alguna manera con
                                                            nosotros (por
                                                            ejemplo, el modelo
                                                            de la computadora
                                                            portátil o
                                                            dispositivo móvil y
                                                            la versión del
                                                            sistema operativo
                                                            que utiliza). Puede
                                                            obtener más
                                                            información sobre
                                                            nuestro uso de estas
                                                            tecnologías (y cómo
                                                            administrar su uso)
                                                            en nuestro{" "}
                                                            <Link
                                                                inline={true}
                                                                target="_blank"
                                                                href="/about/cookie-policy"
                                                            >
                                                                Aviso de Cookies
                                                            </Link>
                                                            .
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="use-of-info"
                                    className={css(styles.sectionTitle)}
                                >
                                    Uso de datos
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy utiliza la información
                                    recopilada con el fin de:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>proporcionar el Servicio</li>
                                    <li>personalizar su experiencia</li>
                                    <li>
                                        comunicarnos con usted sobre su cuenta y
                                        nuestro Servicio (incluida la respuesta
                                        a consultas y compartirleinformación
                                        sobre nuevas funciones y ofertas que
                                        pueden ser de su interés)
                                    </li>
                                    <li>
                                        permitir su participación en programas
                                        especiales que podemos ofrecer en
                                        asociaciones con terceros (si elige
                                        participar en dichos programas
                                        especiales)
                                    </li>
                                    <li>
                                        comprender y mejorar nuestro Servicio y
                                        desarrollar ofertas educativas nuevas o
                                        mejoradas
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    También podemos utilizar elementos de datos
                                    no personales (como información no
                                    identificada, anónima o información de uso
                                    agregada y retroalimentación) para el
                                    desarrollo de productos, investigación,
                                    análisis y otros fines, incluso con el fin
                                    de analizar, mejorar o comercializar nuestro
                                    Servicio, para demostrar el impacto de
                                    nuestro Servicio o para realizar
                                    investigaciones educativas.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(1)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[1]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[1] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        <strong>
                                                            Khan Academy usa sus
                                                            datos de las
                                                            siguientes maneras:
                                                        </strong>
                                                    </p>
                                                    <br />
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Para brindar
                                                                nuestro
                                                                Servicio.
                                                            </strong>{" "}
                                                            Khan Academy utiliza
                                                            sus datos para
                                                            operar, mantener y
                                                            proporcionar todas
                                                            las funciones de
                                                            nuestro Servicio.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Para
                                                                personalizar su
                                                                experiencia.
                                                            </strong>{" "}
                                                            Usamos sus datos
                                                            para personalizar su
                                                            experiencia mientras
                                                            usa el Servicio,
                                                            incluso en varios
                                                            dispositivos que
                                                            puede usar para
                                                            acceder al Servicio.
                                                            Por ejemplo, Khan
                                                            Academy recuerda su
                                                            actividad reciente
                                                            para que podamos
                                                            recomendarle el
                                                            contenido más
                                                            apropiado en su
                                                            próxima visita y
                                                            brindarle
                                                            experiencias de
                                                            aprendizaje
                                                            personalizadas.
                                                            Podemos procesar su
                                                            información
                                                            utilizando IA (como
                                                            cuando utiliza
                                                            Khanmigo, nuestra
                                                            oferta de
                                                            herramientas y
                                                            servicios impulsados
                                                            por IA).
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Para
                                                                comunicarnos
                                                                contigo.
                                                            </strong>{" "}
                                                            Usamos sus datos
                                                            para comunicarnos
                                                            con usted acerca de
                                                            su cuenta y
                                                            responder a sus
                                                            consultas. También
                                                            podemos utilizar sus
                                                            datos para brindarle
                                                            información sobre
                                                            las funciones, los
                                                            servicios y otras
                                                            ofertas de Khan
                                                            Academy que pueden
                                                            ser de su interés, y
                                                            comunicarnos con
                                                            usted sobre nuestra
                                                            misión filantrópica
                                                            y la recaudación de
                                                            fondos para nuestra
                                                            misión.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Para permitir su
                                                                participación en
                                                                los acuerdos de
                                                                asociación de
                                                                Khan Academy.
                                                            </strong>{" "}
                                                            Usamos sus datos
                                                            para permitir su
                                                            participación en
                                                            programas o
                                                            funciones que
                                                            podemos ofrecer en
                                                            asociación con
                                                            terceros, en la
                                                            medida en que decida
                                                            participar en dichos
                                                            programas.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Para comprender,
                                                                mejorar y
                                                                desarrollar
                                                                nuestro
                                                                Servicio.
                                                            </strong>{" "}
                                                            Khan Academy utiliza
                                                            información para
                                                            comprender y
                                                            analizar las
                                                            tendencias de uso,
                                                            los comportamientos
                                                            de aprendizaje y las
                                                            preferencias de
                                                            nuestros usuarios,
                                                            para mejorar la
                                                            forma en que
                                                            funciona y se ve el
                                                            Servicio, y para
                                                            crear nuevas
                                                            características y
                                                            funcionalidades.
                                                            Para mejorar la
                                                            precisión y la
                                                            eficacia de nuestro
                                                            Servicio, revisamos
                                                            manualmente parte
                                                            del Contenido de
                                                            Usuario (como se
                                                            define en la Sección
                                                            5.1 (Contenido de
                                                            Usuario y Propiedad)
                                                            de nuestras
                                                            Condiciones de
                                                            Servicio.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Desarrollar
                                                                nuevas ofertas
                                                                educativas.
                                                            </strong>{" "}
                                                            Podemos utilizar la
                                                            información para
                                                            mantener,
                                                            desarrollar,
                                                            respaldar y mejorar
                                                            nuestro Servicio y
                                                            otros productos y
                                                            servicios
                                                            educativos, y para
                                                            la investigación
                                                            educativa.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Por razones
                                                                legales, de
                                                                cumplimiento o
                                                                de seguridad.
                                                            </strong>{" "}
                                                            Podemos revisar o
                                                            divulgar información
                                                            para cumplir con las
                                                            leyes, reglas o
                                                            regulaciones
                                                            aplicables y
                                                            nuestros Términos de
                                                            Servicio, incluida
                                                            la protección de la
                                                            seguridad y los
                                                            derechos de Khan
                                                            Academy, los
                                                            usuarios y el
                                                            público en general.
                                                            Los chats con
                                                            Khanmigo están
                                                            sujetos a revisión
                                                            por motivos de
                                                            seguridad y
                                                            cumplimiento.
                                                        </li>
                                                    </ul>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para obtener información
                                                        sobre el tratamiento de
                                                        los datos personales
                                                        relevantes para
                                                        visitantes
                                                        internacionales fuera de
                                                        los Estados Unidos,
                                                        consulte{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#regional-info"
                                                        >
                                                            Información Regional
                                                        </Link>
                                                        .
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="sharing"
                                    className={css(styles.sectionTitle)}
                                >
                                    Divulgación de datos
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy se preocupa mucho por proteger
                                    los datos personales que nos proporciona. No
                                    vendemos sus datos personales a terceros.
                                    Esta sección explica las circunstancias en
                                    las que podemos divulgar los datos
                                    personales con terceros.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Podemos divulgar datos personales:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        con otros usuarios de nuestro Servicio,
                                        si utiliza funciones que le permiten
                                        compartir sus datos con (o hacerla
                                        accesible para) otros.
                                    </li>
                                    <li>
                                        con proveedores, consultores y otros
                                        proveedores de servicios que trabajan en
                                        nuestro nombre
                                    </li>
                                    <li>
                                        con otros usuarios asociados a su
                                        cuenta, como un padre, un profesor o un
                                        entrenador.
                                    </li>
                                    <li>
                                        con su escuela, si está utilizando
                                        nuestro Servicio con fines escolares
                                        (consulte el{" "}
                                        <Link inline={true} href="#schools">
                                            Uso por Parte de las Escuelas y los
                                            Estudiantes
                                        </Link>{" "}
                                        para obtener más información).
                                    </li>
                                    <li>
                                        con su consentimiento (incluidas las
                                        aplicaciones de terceros que elija
                                        utilizar, como los servicios
                                        complementarios o un Servicio de
                                        autenticación). Si elige utilizar una
                                        aplicación o servicio de terceros, el
                                        uso de sus datos por parte del tercero
                                        se regirá por el aviso de privacidad de
                                        esa parte.
                                    </li>
                                    <li>
                                        en relación con transferencias
                                        comerciales (debido a fusiones y
                                        adquisiciones).
                                    </li>
                                    <li>
                                        para fines de cumplimiento, como cuando
                                        sea razonablemente necesario para
                                        proteger la seguridad de nuestros
                                        usuarios o del Servicio, o cuando lo
                                        permita la ley.
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    También podemos divulgar información anónima
                                    o agregada que no identifica razonablemente
                                    a ninguna persona.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(2)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[2]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[2] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        <strong>
                                                            Khan Academy puede
                                                            divulgar o
                                                            transferir sus datos
                                                            de las siguientes
                                                            maneras:
                                                        </strong>
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cuando la
                                                            información es
                                                            visible para otros
                                                            en el Servicio de
                                                            forma predeterminada
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Ciertas características
                                                        y funciones del Servicio
                                                        pueden divulgar sus
                                                        datos a o hacerla
                                                        accesible a otras
                                                        personas. Por ejemplo,
                                                        sus datos pueden ser
                                                        visibles para otras
                                                        personas en las
                                                        siguientes
                                                        circunstancias:
                                                    </p>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Información que
                                                                publique en
                                                                espacios
                                                                públicos del
                                                                Servicio.
                                                            </strong>{" "}
                                                            Cuando publica una
                                                            pregunta o respuesta
                                                            en el Servicio, su
                                                            perfil, que podría
                                                            incluir su nombre y
                                                            una breve biografía,
                                                            así como el
                                                            contenido de su
                                                            comentario
                                                            publicado, es
                                                            visible para otras
                                                            personas en el
                                                            Servicio. Al igual
                                                            que con la mayoría
                                                            de los servicios en
                                                            línea, una vez que
                                                            sus datos están
                                                            disponibles para
                                                            otros en línea, los
                                                            destinatarios o
                                                            cualquier otro
                                                            visitante del sitio
                                                            web pueden
                                                            recopilarla y
                                                            utilizarla sin
                                                            restricciones. Al
                                                            igual que con la
                                                            seguridad en línea
                                                            en general,
                                                            considere qué datos
                                                            personales (si
                                                            corresponde) desea
                                                            divulgar en su
                                                            perfil o
                                                            publicaciones. Le
                                                            recomendamos
                                                            encarecidamente que
                                                            no utilice su nombre
                                                            real (u otra
                                                            información que
                                                            pueda usarse para
                                                            identificarlo) al
                                                            crear su nombre de
                                                            usuario (o perfil).
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Información
                                                                divulgada cuando
                                                                su cuenta está
                                                                conectada a otra
                                                                cuenta de
                                                                usuario.
                                                            </strong>{" "}
                                                            Cuando su cuenta
                                                            está conectada a un
                                                            maestro o
                                                            entrenador, o a sus
                                                            padres, esa persona
                                                            podrá ver la
                                                            información de su
                                                            perfil y su
                                                            actividad de
                                                            aprendizaje en el
                                                            Servicio, como qué
                                                            videos ha visto, las
                                                            preguntas y
                                                            respuestas que
                                                            publica, historial
                                                            de chat y otra
                                                            información de uso.
                                                            Esta información
                                                            puede incluir su
                                                            nombre (no solo su
                                                            nombre de usuario),
                                                            así como información
                                                            en el perfil de su
                                                            cuenta y la
                                                            configuración de su
                                                            cuenta.
                                                        </li>
                                                    </ul>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Con su
                                                            consentimiento o
                                                            según sus
                                                            instrucciones
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Puede dar su
                                                        consentimiento o
                                                        autorización para
                                                        divulgar sus datos a
                                                        aplicaciones o servicios
                                                        de terceros de varias
                                                        formas. Tenga en cuenta
                                                        que estos terceros no se
                                                        rigen por Khan Academy
                                                        ni por los términos de
                                                        este Aviso de
                                                        Privacidad. Le
                                                        recomendamos que revise
                                                        el aviso de privacidad
                                                        de cualquier aplicación
                                                        o servicio de terceros
                                                        antes de autorizar su
                                                        acceso a la información
                                                        de su cuenta de Khan
                                                        Academy.
                                                    </p>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Podemos divulgar
                                                                información a
                                                                aplicaciones de
                                                                terceros que
                                                                usted autorice.
                                                            </strong>{" "}
                                                            Los desarrolladores
                                                            de aplicaciones de
                                                            terceros y los
                                                            proveedores de
                                                            servicios pueden
                                                            crear servicios
                                                            complementarios para
                                                            nuestra plataforma,
                                                            como una aplicación
                                                            móvil para
                                                            estudiantes ciegos o
                                                            con baja visión.
                                                            También pueden usar
                                                            nuestro contenido de
                                                            Khan Academy para
                                                            crear aplicaciones y
                                                            servicios no
                                                            afiliados. Si
                                                            conecta su cuenta de
                                                            Khan Academy a una
                                                            aplicación o
                                                            servicio de
                                                            terceros, o aprueba
                                                            el acceso a su
                                                            cuenta de Khan
                                                            Academy por parte de
                                                            un tercero, acepta
                                                            que Khan Academy
                                                            divulgue sus datos
                                                            con ese tercero.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Podemos divulgar
                                                                información a
                                                                herramientas de
                                                                Inicio de Sesión
                                                                Único de
                                                                terceros que
                                                                elija.
                                                            </strong>{" "}
                                                            Khan Academy le
                                                            brinda la
                                                            oportunidad de
                                                            registrar una cuenta
                                                            con (y/o iniciar
                                                            sesión en) Khan
                                                            Academy mediante el
                                                            uso de un servicio
                                                            de autenticación de
                                                            inicio de sesión
                                                            único. Si elige
                                                            utilizar el Servicio
                                                            de autenticación,
                                                            estos servicios de
                                                            terceros pueden
                                                            recopilar o inferir
                                                            información sobre
                                                            usted, incluida
                                                            información sobre su
                                                            uso de nuestro
                                                            Servicio (es decir,
                                                            su actividad de
                                                            inicio de sesión),
                                                            de acuerdo con sus
                                                            propios avisos de
                                                            privacidad.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Podemos divulgar
                                                                información en
                                                                relación con
                                                                programas
                                                                especiales en
                                                                los que
                                                                participa.
                                                            </strong>{" "}
                                                            Si participa en
                                                            programas especiales
                                                            en los que Khan
                                                            Academy se asocia
                                                            con terceros, Khan
                                                            Academy puede
                                                            divulgar información
                                                            recopilada de usted
                                                            o sobre usted a sus
                                                            socios externos para
                                                            facilitar el
                                                            programa o los
                                                            servicios que se
                                                            ofrecen. Antes de
                                                            que decida
                                                            participar en un
                                                            programa especial,
                                                            le informaremos
                                                            sobre si se divulga
                                                            información y qué
                                                            información se
                                                            divulga con los
                                                            terceros que
                                                            proporcionen ese
                                                            programa especial.
                                                            Estos socios pueden
                                                            utilizar su
                                                            información como se
                                                            describe en sus
                                                            propias políticas de
                                                            privacidad.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Podemos divulgar
                                                                información con
                                                                su
                                                                consentimiento.
                                                            </strong>{" "}
                                                            Khan Academy no
                                                            divulga sus datos a
                                                            organizaciones
                                                            externas para su uso
                                                            promocional o de
                                                            marketing. En
                                                            algunos casos, es
                                                            posible que pueda
                                                            otorgarnos permiso
                                                            para divulgar sus
                                                            datos a socios
                                                            autorizados,
                                                            organizaciones sin
                                                            fines de lucro y
                                                            otras entidades que
                                                            no están afiliadas a
                                                            Khan Academy. En
                                                            estos casos, solo
                                                            proporcionaremos a
                                                            estos terceros la
                                                            información que nos
                                                            haya autorizado o
                                                            solicitado que
                                                            divulguemos, para el
                                                            propósito especifico
                                                            que usted autorizó y
                                                            no para fines
                                                            promocionales y de
                                                            marketing.
                                                        </li>
                                                    </ul>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Podemos divulgar
                                                            información a su
                                                            escuela
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Si es un usuario de la
                                                        escuela o un maestro,
                                                        Khan Academy puede
                                                        divulgar cierta
                                                        información a su
                                                        escuela. Para obtener
                                                        más información,
                                                        consulte la sección
                                                        titulada{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#schools"
                                                        >
                                                            Uso por Parte de las
                                                            Escuelas y los
                                                            Estudiantes
                                                        </Link>
                                                        .
                                                    </p>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Podemos divulgar
                                                            información no
                                                            identificada o
                                                            agregada a otros.
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        En determinadas
                                                        circunstancias, Khan
                                                        Academy puede divulgar
                                                        información anónima o
                                                        agregada que no lo
                                                        identifica
                                                        razonablemente como
                                                        individuo para varios
                                                        propósitos. Por ejemplo,
                                                        podemos divulgar
                                                        información anónima con
                                                        socios comerciales para
                                                        mejorar nuestro Servicio
                                                        u ofertas o para
                                                        realizar investigaciones
                                                        educativas. Si
                                                        divulgamos información a
                                                        terceros con fines de
                                                        investigación o
                                                        desarrollo de productos,
                                                        dicha información se
                                                        agregará y/o suprimirá
                                                        para evitar
                                                        razonablemente la
                                                        identificación de
                                                        personas específicas.
                                                    </p>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Divulgaremos
                                                            información a
                                                            empleados y
                                                            proveedores de
                                                            servicios.
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para brindar nuestro
                                                        Servicio, Khan Academy
                                                        puede divulgar
                                                        información a nuestros
                                                        empleados y proveedores
                                                        confiables, proveedores
                                                        de servicios externos u
                                                        otras personas, como
                                                        entidades que brindan
                                                        facturación, atención al
                                                        cliente, análisis,
                                                        hospedaje, tratamiento
                                                        de datos, marketing y
                                                        servicios similares.
                                                        Cuando divulguemos
                                                        información a
                                                        proveedores o
                                                        proveedores de servicios
                                                        de terceros, estos
                                                        terceros están obligados
                                                        por contrato a mantener
                                                        la seguridad y
                                                        confidencialidad de esa
                                                        información.{" "}
                                                        <Link
                                                            inline={true}
                                                            target="_blank"
                                                            href="https://support.khanacademy.org/hc/articles/4407295921805-What-are-the-subprocessors-that-Khan-Academy-uses-"
                                                        >
                                                            Este artículo sobre
                                                            terceros proveedores
                                                            de servicios
                                                        </Link>
                                                        proporciona más
                                                        información sobre
                                                        quiénes son nuestros
                                                        sub-encargados y qué
                                                        servicios prestan.
                                                    </p>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Podemos divulgar
                                                            datos con fines
                                                            legales o
                                                            comerciales.
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Podemos divulgar
                                                                información en
                                                                el contexto de
                                                                un cambio de
                                                                negocio,
                                                                incluida una
                                                                fusión o
                                                                adquisición.
                                                            </strong>{" "}
                                                            En el caso de que
                                                            Khan Academy esté
                                                            involucrado en una
                                                            fusión, adquisición,
                                                            quiebra, cambio de
                                                            control o cualquier
                                                            forma de venta de
                                                            algunos o todos
                                                            nuestros activos,
                                                            sus datos puede ser
                                                            transferida o
                                                            divulgada en
                                                            relación con dicha
                                                            transacción
                                                            comercial. Si la
                                                            transacción implica
                                                            la transferencia de
                                                            Datos Personales del
                                                            Estudiante a un
                                                            tercero,
                                                            solicitaremos al
                                                            nuevo propietario
                                                            que continúe
                                                            cumpliendo con los
                                                            términos provistos
                                                            en este Aviso de
                                                            Privacidad, o le
                                                            proporcionaremos a
                                                            la Escuela un aviso
                                                            y la oportunidad de
                                                            optar por no
                                                            participar en la
                                                            transferencia de
                                                            datos personales del
                                                            estudiante
                                                            eliminando los datos
                                                            personales del
                                                            estudiante antes de
                                                            que se produzca la
                                                            transferencia.
                                                        </li>
                                                        <li>
                                                            Otras instancias.
                                                            Khan Academy puede
                                                            divulgar datos si
                                                            creemos de buena fe
                                                            que hacerlo es
                                                            razonablemente
                                                            necesario para: (a)
                                                            satisfacer cualquier
                                                            ley, regulación,
                                                            proceso legal o
                                                            solicitud
                                                            gubernamental
                                                            aplicable; (b) hacer
                                                            cumplir los{" "}
                                                            <Link
                                                                target="_blank"
                                                                inline={true}
                                                                href="/about/docs/khan-academy-terms-of-service"
                                                            >
                                                                Términos de
                                                                Servicio
                                                            </Link>
                                                            , incluida la
                                                            investigación de
                                                            posibles violaciones
                                                            de los mismos; (c)
                                                            investigar o
                                                            defendernos contra
                                                            cualquier reclamo o
                                                            acusaciones de
                                                            terceros; (d)
                                                            detectar, prevenir o
                                                            abordar de otro modo
                                                            el fraude, la
                                                            seguridad o los
                                                            problemas técnicos;
                                                            (e) proteger los
                                                            derechos, la
                                                            propiedad o la
                                                            seguridad personal
                                                            de Khan Academy (y
                                                            su equipo), nuestros
                                                            usuarios o el
                                                            público; o (f) según
                                                            lo requiera o
                                                            permita la ley.
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="retention"
                                    className={css(styles.sectionTitle)}
                                >
                                    Retención de Datos Personales
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Nuestra práctica es retener sus datos
                                    personales solo durante el tiempo necesario
                                    para brindarle nuestros servicios,
                                    incluyendo el mantenimiento de su cuenta en
                                    Khan Academy. Al determinar cuánto tiempo
                                    conservaremos sus datos personales,
                                    consideramos cómo el mantener esta
                                    información ayudará al usuario (o a la
                                    escuela, en el caso de cuentas escolares),
                                    nuestras obligaciones legales y otras
                                    necesidades comerciales. Nuestros períodos
                                    de retención varían según el tipo de dato
                                    involucrado, pero, en general, tomamos en
                                    cuenta los siguientes factores para
                                    determinar cuánto tiempo retenemos los datos
                                    personales:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Si los datos son necesarios para
                                        mantener una cuenta en Khan Academy
                                    </li>
                                    <li>
                                        Si los datos son necesarios para apoyar
                                        un propósito educativo
                                    </li>
                                    <li>
                                        Si tenemos una obligación contractual de
                                        retener los datos
                                    </li>
                                    <li>
                                        Si necesitamos retener los datos para
                                        fines comerciales legítimos, como para
                                        llevar registros o prevenir fraudes o
                                        abusos
                                    </li>
                                    <li>
                                        Si los datos son necesarios para
                                        procesar compras y resolver asuntos
                                        relacionados con pagos, suscripciones o
                                        donaciones
                                    </li>
                                    <li>
                                        Si nuestros usuarios tienen la
                                        posibilidad de acceder y eliminar sus
                                        datos
                                    </li>
                                    <li>
                                        Si nuestros usuarios pudiesen esperar
                                        razonablemente que conservemos los datos
                                        hasta que su cuenta de Khan Academy sea
                                        cerrada o cancelada, o hasta que
                                        soliciten su eliminación
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Cuando no tengamos una necesidad comercial
                                    legítima para tratar sus datos personales,
                                    nuestra política es eliminar o
                                    desidentificar los datos. Podemos retener y
                                    usar datos desidentificados o anonimizados
                                    por períodos más largos para propósitos como
                                    desarrollo de productos, investigación,
                                    análisis y para demostrar el impacto de
                                    nuestro Servicio.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Puede encontrar información adicional sobre
                                    nuestras prácticas de eliminación en nuestro
                                    artículo del Centro de Ayuda "¿Cuáles son
                                    las prácticas de eliminación de Khan
                                    Academy?"
                                </p>
                                <h2
                                    id="advertising"
                                    className={css(styles.sectionTitle)}
                                >
                                    Patrocinio y Publicidad
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Como organización sin fines de lucro, Khan
                                    Academy depende de nuestros patrocinadores,
                                    donantes y otros contribuyentes para
                                    proporcionar los fondos necesarios para
                                    brindar el Servicio gratuito a nuestros
                                    usuarios. De vez en cuando, permitimos que
                                    terceros patrocinen el contenido que se
                                    muestra en nuestro Servicio.
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Por ejemplo, las organizaciones con
                                        fines de lucro pueden querer patrocinar
                                        todo el contenido relacionado con un
                                        tema educativo en particular, como
                                        astronomía o biología.
                                    </li>
                                    <li>
                                        El contenido patrocinado siempre estará
                                        etiquetado (p. Ej., "Patrocinado por
                                        ___”).
                                    </li>
                                    <li>
                                        Khan Academy no divulga sus datos
                                        personales con estos patrocinadores sin
                                        su consentimiento. No proporcionamos a
                                        estos patrocinadores la capacidad de
                                        rastrear o recopilar información sobre
                                        los visitantes o usuarios de nuestro
                                        sitio.
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy no muestra anuncios de terceros
                                    en nuestro Servicio. Es posible que, de vez
                                    en cuando, incorporemos contenido o enlace a
                                    contenido proporcionado por terceros que
                                    pueda ser de su interés y relevante para el
                                    contexto educativo de nuestro Servicio.
                                    Algunos de estos materiales o sitios web
                                    pueden incluir marcas o anuncios según lo
                                    permita el propietario u operador de
                                    terceros. Para obtener más información,
                                    consulte{" "}
                                    <Link inline={true} href="#third-parties">
                                        Enlaces a Terceros
                                    </Link>
                                    .
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Tomamos medidas para evitar la recopilación
                                    de datos con fines publicitarios específicos
                                    cuando creemos que estudiantes o niños están
                                    utilizando el Servicio.
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Por ejemplo, evitamos el uso de
                                        tecnologías de rastreo en páginas web
                                        con contenido dirigido a niños y no
                                        utilizamos tecnologías de rastreo para
                                        publicidad de terceros.
                                    </li>
                                    <li>
                                        Khan Academy utiliza la funcionalidad de
                                        privacidad en YouTube para mostrar
                                        contenido de video en YouTube (consulte
                                        la información adicional en "Más
                                        información").
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Consulte nuestro{" "}
                                    <Link
                                        inline={true}
                                        href="#childrens-privacy"
                                    >
                                        Aviso de Privacidad de Menores
                                    </Link>{" "}
                                    para obtener más información.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(3)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[3]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[3] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>YouTube</strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Hemos activado el "Modo
                                                        de Privacidad Mejorada"
                                                        para los videos de
                                                        YouTube que se muestran
                                                        en el Servicio. Esto
                                                        significa que YouTube no
                                                        coloca cookies ni
                                                        rastrea el
                                                        comportamiento de
                                                        visualización con fines
                                                        publicitarios. Nuestro
                                                        contenido para
                                                        estudiantes no incluye
                                                        ningún video de YouTube
                                                        que no sea parte de
                                                        nuestro contenido.
                                                        Inhabilitamos cierta
                                                        funcionalidad en YouTube
                                                        (llamada funcionalidad
                                                        "rel"), para que no se
                                                        reproduzca contenido
                                                        fuera de nuestro
                                                        contenido. También
                                                        utilizamos las etiquetas
                                                        de "tratamiento dirigido
                                                        a niños" de Google para
                                                        alertar a Google de que
                                                        nuestros videos de
                                                        YouTube pueden ser
                                                        vistos por niños o
                                                        estudiantes. Para
                                                        obtener más información,
                                                        consulte las{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="http://www.google.com/policies/privacy/partners"
                                                        >
                                                            prácticas de
                                                            privacidad de Google
                                                        </Link>
                                                        .
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="transparency"
                                    className={css(styles.sectionTitle)}
                                >
                                    Transparencia y sus elecciones
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Nos tomamos la privacidad muy en serio. Nos
                                    esforzamos por darle el control de las
                                    opciones y decisiones relacionadas con sus
                                    datos personales.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Entendemos que sus datos personales son
                                    importantes para usted y es por eso que
                                    tiene opciones sobre cómo se usan y se
                                    divulgan sus datos personales. Queremos que
                                    tenga acceso a sus datos personales, para
                                    que pueda ayudar a mantenerlos lo más
                                    precisos posible
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Por ejemplo, puede elegir si desea crear una
                                    cuenta (o utilizar el Servicio sin
                                    registrarse). Si se registra para obtener
                                    una cuenta, puede:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Limitar la información opcional que
                                        proporciona.
                                    </li>
                                    <li>
                                        Elegir si desea divulgar datos
                                        personales con (y utilizar) servicios de
                                        terceros
                                    </li>
                                    <li>
                                        Elegir si desea agregar un entrenador a
                                        su cuenta
                                    </li>
                                    <li>
                                        Elegir si desea recibir un correo
                                        electrónico opcional.
                                    </li>
                                    <li>
                                        Actualizar, corregir y eliminar la
                                        información de su cuenta a través de la
                                        configuración de su cuenta.
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Le recomendamos que compruebe regularmente{" "}
                                    <Link
                                        inline={true}
                                        target="_blank"
                                        href="/settings/email"
                                    >
                                        la configuración de su cuenta
                                    </Link>
                                    .
                                </p>
                                <p className={css(styles.paragraph)}>
                                    En algunos casos, los controles
                                    administrativos de las cuentas que se
                                    utilizan en un entorno escolar, incluida la
                                    capacidad de modificar o eliminar la cuenta,
                                    están a cargo de la escuela. Para obtener
                                    más información, consulte nuestro{" "}
                                    <Link
                                        inline={true}
                                        href="#childrens-privacy"
                                    >
                                        Aviso de Privacidad de Menores
                                    </Link>{" "}
                                    y{" "}
                                    <Link inline={true} href="#schools">
                                        Uso por Parte de las Escuelas y los
                                        Estudiantes
                                    </Link>
                                    .
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(4)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[4]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[4] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede utilizar el
                                                            Servicio sin crear
                                                            una cuenta
                                                        </strong>
                                                    </h4>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Puede acceder a la
                                                        mayoría de nuestros
                                                        recursos en línea sin
                                                        proporcionar datos
                                                        personales. Sin embargo,
                                                        si no crea una cuenta,
                                                        Khan Academy no podrá
                                                        proporcionarle ciertas
                                                        características y
                                                        funcionalidades que se
                                                        encuentran en nuestro
                                                        Servicio. Podrá seguir
                                                        viendo contenidos y
                                                        completando ejercicios
                                                        sin una cuenta, pero no
                                                        tendrá todas las
                                                        funciones de la cuenta
                                                        (como ver su
                                                        participación en las
                                                        tareas de clase y hacer
                                                        un seguimiento de su
                                                        actividad de
                                                        aprendizaje). Más
                                                        adelante podrá habilitar
                                                        o acceder a esas
                                                        funciones proporcionando
                                                        a Khan Academy la
                                                        información necesaria
                                                        para crear una cuenta.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede limitar los
                                                            datos personales que
                                                            proporciona
                                                        </strong>
                                                    </h4>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Puede elegir
                                                        proporcionar información
                                                        que no le identifique
                                                        razonablemente ante
                                                        otros. Por ejemplo, le
                                                        recomendamos que
                                                        seleccione un nombre de
                                                        usuario que no esté
                                                        relacionado con su
                                                        nombre real (o que pueda
                                                        ser utilizado para
                                                        identificarle). También
                                                        puede negarse a
                                                        proporcionar cualquier
                                                        información opcional en
                                                        su perfil público.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Los foros de la
                                                            comunidad son
                                                            opcionales
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Usted elige si (y cómo)
                                                        participar en los foros
                                                        de acceso público, como
                                                        por ejemplo, publicar en
                                                        los espacios públicos
                                                        del Servicio. Cuando
                                                        publique una pregunta (o
                                                        una respuesta) en el
                                                        Servicio (o participe de
                                                        otro modo en un foro
                                                        público), su perfil (así
                                                        como el contenido de su
                                                        comentario publicado)
                                                        será visible para otros
                                                        usuarios del Servicio.
                                                        Nuestro Servicio ofrece
                                                        blogs o foros
                                                        comunitarios de acceso
                                                        público. Debe ser
                                                        consciente de que
                                                        cualquier información
                                                        que proporcione en estas
                                                        áreas puede ser leída,
                                                        recopilada y utilizada
                                                        por otros. Los usuarios
                                                        menores no pueden
                                                        publicar en los foros de
                                                        la comunidad (como se
                                                        describe en el Aviso de
                                                        Privacidad de Menores{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#childrens-privacy"
                                                        >
                                                            Aviso de Privacidad
                                                            de Menores
                                                        </Link>
                                                        ).
                                                    </p>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede desconectar (o
                                                            elegir no utilizar)
                                                            aplicaciones de
                                                            terceros
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Usted elige qué
                                                        aplicaciones de terceros
                                                        desea utilizar y puede
                                                        dejar de usarlas en
                                                        cualquier momento. Esta
                                                        funcionalidad es
                                                        opcional y depende
                                                        completamente de usted.
                                                        Por ejemplo, puede
                                                        revocar el acceso de
                                                        Khan Academy a su cuenta
                                                        en cualquier servicio de
                                                        inicio de sesión único
                                                        en cualquier momento
                                                        desconectando la “Cuenta
                                                        vinculada” en la{" "}
                                                        <Link
                                                            inline={true}
                                                            target="_blank"
                                                            href="/settings/account"
                                                        >
                                                            Configuración de la
                                                            Cuenta
                                                        </Link>{" "}
                                                        o actualizando la
                                                        configuración adecuada
                                                        en las preferencias de
                                                        la cuenta del servicio
                                                        de autenticación
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede darse de baja
                                                            de los mensajes de
                                                            correo electrónico
                                                            opcional
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Ocasionalmente, Khan
                                                        Academy puede enviarle
                                                        mensajes de correo
                                                        electrónico sobre
                                                        nuestros productos y
                                                        servicios, o sobre
                                                        productos y servicios
                                                        que pensamos que pueden
                                                        ser de su agrado. Usted
                                                        puede optar por no
                                                        recibir estos correos
                                                        electrónicos haciendo
                                                        clic en el enlace de
                                                        cancelación de la
                                                        suscripción en cualquier
                                                        correo electrónico o
                                                        actualizando su{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="/settings/email"
                                                        >
                                                            configuración de
                                                            Correos
                                                        </Link>
                                                        . Tenga en cuenta que no
                                                        se le permite anular la
                                                        suscripción o excluirse
                                                        de ciertos tipos de
                                                        mensajes relacionados
                                                        con su cuenta, como la
                                                        verificación de la
                                                        cuenta, los cambios o
                                                        actualizaciones de las
                                                        características del
                                                        Servicio, los avisos
                                                        técnicos o de seguridad
                                                        y ciertas comunicaciones
                                                        programáticas (como las
                                                        asignaciones de clases).
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede añadir un
                                                            entrenador, un
                                                            profesor o una
                                                            cuenta escolar a su
                                                            cuenta
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Puede elegir añadir un
                                                        entrenador o profesor a
                                                        su cuenta para que su
                                                        entrenador o profesor
                                                        pueda ver el perfil de
                                                        su cuenta y su actividad
                                                        de aprendizaje en el
                                                        Servicio, como los
                                                        vídeos que ha visto, las
                                                        preguntas y respuestas
                                                        que publica y otra
                                                        información de uso.
                                                        Cuando su cuenta está
                                                        conectada a un
                                                        entrenador, profesor o
                                                        Escuela en el Servicio,
                                                        su entrenador, profesor
                                                        o Escuela podrá ver la
                                                        información de su perfil
                                                        y su actividad de
                                                        aprendizaje en el
                                                        Servicio. Si usted
                                                        vincula su cuenta
                                                        personal a una cuenta de
                                                        la Escuela, un profesor
                                                        o Escuela conectados
                                                        verán su actividad de
                                                        aprendizaje personal,
                                                        así como la actividad de
                                                        aprendizaje del uso de
                                                        la Escuela. Un
                                                        entrenador o profesor
                                                        conectado también podrá
                                                        ver su nombre (no sólo
                                                        su nombre de usuario),
                                                        así como su dirección de
                                                        correo electrónico, si
                                                        incluye esa información
                                                        en el perfil de su
                                                        cuenta. Tenga en cuenta
                                                        que parte de la
                                                        información del perfil
                                                        de la cuenta y de las
                                                        conexiones de los
                                                        profesores para ciertas
                                                        cuentas de la Escuela
                                                        están controladas por la
                                                        Escuela.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede obtener más
                                                            información sobre
                                                            las cookies y cómo
                                                            gestionar la
                                                            configuración de las
                                                            mismas en nuestro
                                                            Aviso sobre las
                                                            cookies
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para proporcionar
                                                        aprendizaje
                                                        personalizado y una
                                                        experiencia de alta
                                                        calidad para nuestros
                                                        usuarios, podremos usar
                                                        cookies y tecnologías
                                                        similares que recopilen
                                                        automáticamente cierta
                                                        información de su
                                                        navegador o dispositivo
                                                        cuando visite nuestro
                                                        sitio web, lea nuestros
                                                        correos, use nuestro
                                                        Servicio o interactúe
                                                        con nosotros de otra
                                                        manera. Usted puede
                                                        manejar cookies
                                                        (funcionales) en nuestro
                                                        Centro de Preferencias
                                                        de Cookies, incluyendo
                                                        la capacidad de optar
                                                        directamente por no
                                                        aceptar ciertas cookies
                                                        de terceros. Tenga en
                                                        cuenta que la elección
                                                        de eliminar o rechazar
                                                        ciertas cookies podría
                                                        limitar su uso del
                                                        Servicio. Para más
                                                        información sobre
                                                        nuestro uso de cookies y
                                                        otras tecnologías
                                                        similares, consulte
                                                        nuestro{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="/about/cookie-policy"
                                                        >
                                                            Aviso sobre Cookies
                                                        </Link>
                                                        .
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Puede compartir
                                                            información sobre
                                                            los cursos que está
                                                            estudiando a partir
                                                            de las funciones
                                                            para compartir
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Ofrecemos funciones para
                                                        compartir claramente
                                                        marcadas, que le
                                                        permiten compartir
                                                        información sobre los
                                                        cursos o temas que está
                                                        aprendiendo a través del
                                                        Servicio. El uso de las
                                                        funciones para compartir
                                                        es enteramente a su
                                                        elección.
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="settings"
                                    className={css(styles.sectionTitle)}
                                >
                                    Configuración de su cuenta
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Queremos que tenga acceso a sus datos, para
                                    que pueda contribuir a mantenerla lo más
                                    precisa posible. Si se registra y
                                    proporciona información a Khan Academy,
                                    puede actualizar, corregir o eliminar su
                                    cuenta e información en cualquier momento
                                    revisando la información de su perfil y sus
                                    preferencias en la página de configuración
                                    de su cuenta.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Los padres (no los menores) pueden modificar
                                    o eliminar las cuentas de los usuarios
                                    infantiles, tal y como se describe en
                                    nuestro{" "}
                                    <Link
                                        inline={true}
                                        href="#childrens-privacy"
                                    >
                                        Aviso de Privacidad de Infantes
                                    </Link>
                                    . Los padres o los usuarios de la escuela
                                    que soliciten modificar o eliminar las
                                    cuentas de la escuela pueden dirigirse a la
                                    Escuela.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    En la sección "Más información" encontrará
                                    más información sobre cómo puede acceder,
                                    actualizar, corregir o eliminar su cuenta en
                                    la configuración de la misma.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(5)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[5]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[5] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Acceder, actualizar
                                                            y corregir sus datos
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Puede acceder,
                                                        actualizar y corregir
                                                        sus datos personales en
                                                        cualquier momento
                                                        entrando en su cuenta y
                                                        actualizando la
                                                        información pertinente
                                                        en la página de
                                                        configuración de su
                                                        cuenta.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Eliminar su cuenta y
                                                            sus datos
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para solicitar la
                                                        eliminación de sus datos
                                                        en cualquier momento,
                                                        acceda a su cuenta y
                                                        seleccione "eliminar su
                                                        cuenta" en la página de
                                                        configuración. Puede
                                                        obtener más información
                                                        en nuestro{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://khanacademy.zendesk.com/hc/articles/202263014-How-can-I-cancel-or-delete-my-account-"
                                                        >
                                                            Centro de Asistencia
                                                        </Link>
                                                        .
                                                    </p>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            Tenga en cuenta que
                                                            sus datos se
                                                            conservarán en una
                                                            copia de seguridad
                                                            durante un máximo de
                                                            una semana. Si
                                                            vuelve a entrar en
                                                            su cuenta en las
                                                            siguientes 48 horas,
                                                            su cuenta <u>no</u>{" "}
                                                            se eliminará y
                                                            tendrá que volver a
                                                            pasar por el proceso
                                                            de eliminación.
                                                        </li>
                                                        <li>
                                                            Es posible que no
                                                            podamos eliminar los
                                                            datos en todos los
                                                            casos. Por ejemplo,
                                                            podemos retener
                                                            ciertos datos según
                                                            sea necesario para
                                                            prevenir el fraude o
                                                            el abuso futuro,
                                                            para el
                                                            mantenimiento de
                                                            registros u otros
                                                            fines comerciales
                                                            legítimos, o si lo
                                                            exige la ley. Los
                                                            datos personales
                                                            reservados seguirán
                                                            estando sujetos a
                                                            los términos de esta
                                                            Aviso de Privacidad.
                                                        </li>
                                                        <li>
                                                            A menos que
                                                            recibamos una
                                                            solicitud de
                                                            eliminación,
                                                            conservaremos su
                                                            información mientras
                                                            su cuenta esté
                                                            activa o sea
                                                            razonablemente
                                                            necesaria para
                                                            cumplir con los
                                                            propósitos para los
                                                            cuales fue recabada.
                                                            También podemos
                                                            conservar los datos
                                                            que hayan sido
                                                            retirados o
                                                            agregados de forma
                                                            que ya no puedan
                                                            identificar
                                                            razonablemente a una
                                                            persona en
                                                            particular.
                                                        </li>
                                                        <li>
                                                            Los padres pueden
                                                            modificar o eliminar
                                                            las cuentas de los
                                                            usuarios menores que
                                                            estén conectadas a
                                                            la cuenta de los
                                                            padres, excepto en
                                                            el caso de
                                                            determinadas Cuentas
                                                            Escolares.
                                                        </li>
                                                    </ul>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cuentas Escolares
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        La configuración
                                                        predeterminada de las
                                                        cuentas utilizadas por o
                                                        bajo la dirección de una
                                                        Escuela puede diferir
                                                        dependiendo de la forma
                                                        en que Khan Academy es
                                                        utilizado por una
                                                        Escuela y los términos
                                                        del acuerdo entre la
                                                        Escuela y Khan Academy.
                                                        En algunos casos, los
                                                        controles
                                                        administrativos,
                                                        incluida la capacidad de
                                                        modificar o eliminar la
                                                        cuenta, están en manos
                                                        de la Escuela. Si tiene
                                                        una cuenta de escuela,
                                                        póngase en contacto con
                                                        el administrador de su
                                                        escuela para obtener
                                                        información sobre su
                                                        cuenta. Para más
                                                        información, por favor
                                                        revise{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#schools"
                                                        >
                                                            Uso por Parte de las
                                                            Escuelas y los
                                                            Estudiantes
                                                        </Link>
                                                        .
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="security"
                                    className={css(styles.sectionTitle)}
                                >
                                    Seguridad de sus Datos Personales
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy se compromete a mantener
                                    seguros sus datos personales.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Algunas de las formas en que protegemos sus
                                    datos personales son:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Ciframos su información personal cuando
                                        se almacena en condiciones de espera
                                    </li>
                                    <li>
                                        Protegemos sus datos personales con
                                        encriptación durante la transmisión a
                                        través de la Internet pública
                                    </li>
                                    <li>
                                        Utilizamos medidas de seguridad
                                        organizativos y técnicos razonables
                                        diseñados para ayudar a proteger la
                                        privacidad y la seguridad de sus datos
                                        personales
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Algunas de las formas en las que le animamos
                                    a proteger sus datos personales son:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Le recomendamos que cree un nombre de
                                        usuario que no revele su identidad
                                    </li>
                                    <li>
                                        Le recomendamos que cree (y mantenga)
                                        una contraseña segura
                                    </li>
                                    <li>
                                        Le recomendamos que sea reflexivo sobre
                                        lo que publica y que siga aprendiendo
                                        sobre la seguridad en línea
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Utilizamos medidas de seguridad de seguridad
                                    razonables para proteger nuestro Servicio y
                                    sus datos personales, pero ninguna medida de
                                    seguridad es perfecta.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(6)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[6]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[6] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            La seguridad es
                                                            importante para
                                                            usted y para Khan
                                                            Academy
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para proteger su
                                                        privacidad y seguridad,
                                                        tomamos medidas
                                                        razonables para
                                                        verificar su identidad
                                                        antes de conceder el
                                                        acceso a la cuenta o
                                                        hacer correcciones a sus
                                                        datos. Por ejemplo,
                                                        podemos pedirle que
                                                        proporcione ciertos
                                                        datos para confirmar su
                                                        identidad, y podemos
                                                        exigirle que cree y
                                                        utilice una contraseña
                                                        para acceder a ciertas
                                                        partes de nuestro
                                                        Servicio. Le
                                                        recomendamos
                                                        encarecidamente que cree
                                                        y mantenga una
                                                        contraseña sólida para
                                                        ayudar a garantizar la
                                                        seguridad de su cuenta.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Utilizamos medidas
                                                            de seguridad
                                                            razonables para
                                                            proteger nuestro
                                                            Servicio y su
                                                            información
                                                            personal, pero
                                                            ninguna medida de
                                                            seguridad es
                                                            perfecta
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Khan Academy utiliza
                                                        medidas de seguridad
                                                        físicas, administrativas
                                                        y técnicas razonables
                                                        diseñadas para proteger
                                                        la integridad y la
                                                        seguridad de sus datos
                                                        personales que
                                                        mantenemos en relación
                                                        con nuestro Servicio.
                                                        Sin embargo, no podemos
                                                        asegurar o garantizar la
                                                        seguridad de todos o
                                                        parte de los datos que
                                                        usted transmite a Khan
                                                        Academy. Por ejemplo,
                                                        ningún servicio de
                                                        Internet o mensaje de
                                                        correo electrónico es
                                                        totalmente seguro o está
                                                        libre de errores. En
                                                        particular, puede que
                                                        los correos electrónicos
                                                        enviados a o desde el
                                                        Servicio no sean
                                                        seguros. Por favor,
                                                        tenga especial cuidado
                                                        al decidir qué
                                                        información nos envía
                                                        por correo electrónico o
                                                        para obtener ayuda de
                                                        soporte. Una vez que
                                                        recibimos la transmisión
                                                        de sus datos, Khan
                                                        Academy hace esfuerzos
                                                        comercialmente
                                                        razonables para
                                                        garantizar la seguridad
                                                        de nuestros sistemas.
                                                        Cuando usted introduce
                                                        datos sensibles,
                                                        encriptamos la
                                                        transmisión de estos
                                                        datos utilizando
                                                        tecnología de capa de
                                                        conexión segura (CCS) o
                                                        tecnologías similares.
                                                        Sin embargo, tenga en
                                                        cuenta que esto no es
                                                        una garantía de que no
                                                        se pueda acceder a dicha
                                                        información, divulgarla,
                                                        alterarla o destruirla
                                                        por una violación de
                                                        cualquiera de nuestras
                                                        salvaguardias físicas,
                                                        técnicas o
                                                        administrativas. En el
                                                        caso de que cualquier
                                                        dato bajo nuestro
                                                        control se vea
                                                        comprometido como
                                                        resultado de una
                                                        violación de la
                                                        seguridad, tomaremos
                                                        medidas razonables para
                                                        investigar la situación
                                                        y le notificaremos el
                                                        incidente de seguridad
                                                        de acuerdo con las leyes
                                                        y reglamentos
                                                        aplicables.
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="third-parties"
                                    className={css(styles.sectionTitle)}
                                >
                                    Enlaces a Terceros
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    El Servicio puede enlazar con sitios web
                                    operados por otras entidades o individuos, y
                                    puede ser enlazado por ellos. Si incluimos
                                    enlaces a terceros y usted hace clic en ese
                                    enlace, saldrá de Khan Academy y se aplicará
                                    el aviso de privacidad de ese tercero. Del
                                    mismo modo, si usted ve un enlace a Khan
                                    Academy en el sitio web de un tercero,
                                    entonces se aplica el aviso de privacidad de
                                    ese tercero.
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Por ejemplo:
                                        <ul className={css(styles.subList)}>
                                            <li>
                                                Si hace clic en un enlace a un
                                                programa educacional
                                                administrado por otra compañía,
                                                entonces irá al sitio web de la
                                                compañía y se aplicará el aviso
                                                de privacidad de la compañía.
                                            </li>
                                            <li>
                                                Usted podrá escoger compartir
                                                información acerca del uso de
                                                Khan Academy en redes sociales.
                                                Si usted lo decide, la red
                                                social podrá usar sus datos
                                                conforme se describe en su aviso
                                                de privacidad.
                                            </li>
                                            <li>
                                                Si está en la página de
                                                Instagram de Khan Academy, el
                                                aviso de privacidad de Instagram
                                                se aplica a esa página de
                                                Instagram de Khan Academy.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Este aviso de privacidad de Khan Academy
                                        no se aplica a (y no podemos controlar
                                        las actividades de) esos otros sitios
                                        web de terceros.
                                    </li>
                                    <li>
                                        Usted debe consultar los avisos de
                                        privacidad de esos sitios web de
                                        terceros.
                                    </li>
                                </ul>
                                <h2
                                    id="changes"
                                    className={css(styles.sectionTitle)}
                                >
                                    Cambios a este Aviso de Privacidad
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Khan Academy puede modificar o revisar este
                                    Aviso de Privacidad de vez en cuando. Khan
                                    Academy notificará a los usuarios cualquier
                                    cambio en nuestro Aviso de Privacidad
                                    publicando el Aviso de Privacidad revisado
                                    con una fecha de revisión actualizada en
                                    nuestro Servicio. Si cambiamos este Aviso de
                                    manera sustancial, haremos todo lo posible
                                    para notificarle de los cambios mediante la
                                    publicación de un aviso en nuestro sitio web
                                    antes de que dichos cambios entren en vigor.
                                    Le recomendamos que revise el Aviso de
                                    Privacidad cada vez que visite el Servicio
                                    para mantenerse informado de nuestras
                                    prácticas de privacidad.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    No realizaremos ningún cambio material en
                                    nuestro Aviso de Privacidad que se relacione
                                    con la recopilación o el uso de los Datos
                                    Personales del Estudiante sin notificar
                                    primero a la Escuela y proporcionar una
                                    opción antes de que los Datos Personales del
                                    Estudiante se utilicen de una manera
                                    materialmente diferente a la que se divulgó
                                    cuando se recopilaron los datos.
                                </p>
                                <h2
                                    id="schools"
                                    className={css(styles.sectionTitle)}
                                >
                                    Uso por Parte de las Escuelas y los
                                    Estudiantes
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso sobre el uso por parte de
                                    escuelas y estudiantes complementa nuestro
                                    Aviso de Privacidad en relación con el uso
                                    por parte de las escuelas. Khan Academy es
                                    una organización sin ánimo de lucro dedicada
                                    a proporcionar contenido educativo gratuito.
                                    Nos esforzamos por implementar las mejores
                                    prácticas para proteger la privacidad de
                                    todos nuestros usuarios, estudiantes y no
                                    estudiantes, por igual. Hemos implementado
                                    controles y procedimientos adicionales para
                                    las escuelas, los distritos escolares y los
                                    profesores (denominados colectivamente "
                                    <strong>Escuelas</strong>") cuando utilizan
                                    el Servicio con fines educativos. Cuando el
                                    Servicio se utiliza como parte del programa
                                    educativo de la Escuela, la información
                                    personal relacionada con los estudiantes
                                    usuarios de la Escuela ("
                                    <strong>Usuarios de la Escuela</strong>")
                                    puede incluir información definida como
                                    "registros educativos" por la Ley de
                                    Derechos Educativos y Privacidad de la
                                    Familia ("<strong>FERPA</strong>") u otra
                                    información protegida por leyes estatales
                                    similares de privacidad de datos de
                                    estudiantes. Nos referimos a esta
                                    información como "
                                    <strong>
                                        Datos personales de los estudiantes
                                    </strong>
                                    ”.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    <strong>Nuestro compromiso:</strong>Estamos
                                    orgullosos de apoyar el{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="https://studentprivacypledge.org/"
                                    >
                                        Compromiso de Privacidad del Estudiante
                                    </Link>
                                    . Nuestra recopilación y uso de los Datos
                                    Personales de los Estudiantes se rige por
                                    nuestros contratos con las Escuelas, por
                                    nuestro Aviso de Privacidad y por las leyes
                                    de privacidad aplicables. Por ejemplo,
                                    trabajamos con los centros educativos para
                                    proteger los datos personales de los
                                    estudiantes de acuerdo con la ley FERPA.
                                    Para usuarios de centros escolares menores
                                    de 13 años, nuestras prácticas de privacidad
                                    se rigen por la Ley de Protección de la
                                    Privacidad de los Menores en Internet (“
                                    <strong>COPPA</strong>”). Si tiene alguna
                                    pregunta sobre la revisión, modificación o
                                    eliminación de los datos personales de un
                                    usuario escolar, póngase en contacto
                                    directamente con su Escuela.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    <strong>
                                        Creación de Cuentas Escolares
                                    </strong>
                                    : Tenga en cuenta que para que las cuentas
                                    de los Usuarios de la Escuela estén
                                    asociadas a una Escuela y sean reconocidas
                                    como Cuentas de la Escuela (tal y como se
                                    definen en nuestras{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="/about/docs/khan-academy-terms-of-service"
                                    >
                                        Condiciones de Servicio
                                    </Link>
                                    ), las cuentas deben ser creadas por o bajo
                                    la dirección de una Escuela, utilizando una
                                    dirección de correo electrónico de la
                                    escuela y asociadas a una clase de la
                                    Escuela en el Servicio. Por ejemplo, una
                                    Cuenta Escolar se crea cuando:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        un profesor crea el nombre de usuario,
                                        el nombre de usuario y la contraseña
                                        para establecer cuentas de Usuario de la
                                        Escuela y crea una clase en el Servicio
                                    </li>
                                    <li>
                                        un profesor inscribe una clase mediante
                                        Google Classroom, Clever o un servicio
                                        similar de inicio de sesión único para
                                        uso de la Escuela
                                    </li>
                                    <li>
                                        un Usuario de la Escuela crea una cuenta
                                        por indicación de una Escuela,
                                        utilizando una dirección de correo
                                        electrónico de la Escuela y la asocia
                                        con una clase de la Escuela en el
                                        Servicio
                                    </li>
                                    <li>
                                        las cuentas son creadas conforme a un
                                        contrato separado entre Khan Academy y
                                        el distrito escolar (o agencia
                                        educativa) que especifica que las
                                        cuentas son Cuentas de la Escuela
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    En los casos en los que no tenemos un
                                    contrato separado con un distrito escolar o
                                    agencia educativa, podemos requerir la
                                    notificación de que las cuentas se utilizan
                                    para fines escolares con el fin de
                                    reconocerlas como Cuentas Escolares. Si
                                    usted es un centro educativo, póngase en
                                    contacto con nuestro{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="mailto:schoolpartnerships@khanacademy.org"
                                    >
                                        Equipo de Asociaciones Escolares
                                    </Link>{" "}
                                    para obtener Información Adicional sobre
                                    cómo asegurarse de que las cuentas de los
                                    estudiantes se configuran y gestionan como
                                    Cuentas Escolares. Las cuentas incluidas en
                                    una suscripción de Distritos Khan Academy
                                    son Cuentas Escolares.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Revise “Información Adicional” para ver más
                                    información sobre:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        Algunas de las formas específicas en que
                                        utilizamos y protegemos los Datos
                                        Personales de los Estudiantes
                                    </li>
                                    <li>
                                        Cómo divulgamos los Datos Personales de
                                        los Estudiantes
                                    </li>
                                    <li>No hay publicidad dirigida</li>
                                    <li>
                                        Cómo conservamos y eliminamos los Datos
                                        Personales de los Estudiante
                                    </li>
                                    <li>
                                        Preguntas sobre los Datos Personales de
                                        los Estudiantes
                                    </li>
                                </ul>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(7)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[7]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[7] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Algunas de las
                                                            formas específicas
                                                            en que utilizamos y
                                                            protegemos los Datos
                                                            Personales de los
                                                            Estudiantes
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            Recopilamos,
                                                            mantenemos,
                                                            utilizamos y
                                                            compartimos los
                                                            Datos Personales del
                                                            Estudiante sólo para
                                                            fines educativos
                                                            autorizados y como
                                                            se describe en
                                                            nuestra Política de
                                                            Privacidad,
                                                            incluyendo lo
                                                            indicado por la
                                                            Escuela, el Usuario
                                                            de la Escuela y/o el
                                                            padre o tutor legal
                                                            del estudiante (un “
                                                            <strong>
                                                                Padre
                                                            </strong>
                                                            ”).
                                                        </li>
                                                        <li>
                                                            No divulgamos los
                                                            Datos Personales del
                                                            Estudiante para
                                                            fines de publicidad
                                                            dirigida. Tomamos
                                                            medidas para evitar
                                                            el uso de cookies de
                                                            rastreo en los
                                                            sitios web con
                                                            contenido dirigido a
                                                            menores de edad.
                                                        </li>
                                                        <li>
                                                            No construimos un
                                                            perfil personal de
                                                            un Usuario de la
                                                            Escuela que no sea
                                                            para promover un
                                                            propósito educativo
                                                            o según lo
                                                            autorizado por un
                                                            padre.
                                                        </li>
                                                        <li>
                                                            Hemos implementado y
                                                            mantenemos un
                                                            programa de
                                                            seguridad de datos
                                                            diseñado para
                                                            proteger los tipos
                                                            de Datos Personales
                                                            de Estudiantes
                                                            recopilados y
                                                            utilizados por el
                                                            Servicio.
                                                        </li>
                                                        <li>
                                                            Divulgaremos de
                                                            forma clara y
                                                            transparente
                                                            nuestras políticas y
                                                            prácticas de datos a
                                                            nuestros usuarios.
                                                        </li>
                                                        <li>
                                                            Nunca venderemos los
                                                            Datos Personales de
                                                            los Estudiantes.
                                                            Excepto que entremos
                                                            en una transacción
                                                            corporativa, como
                                                            una fusión,
                                                            adquisición, quiebra
                                                            u otra venta de
                                                            activos, que resulte
                                                            en una transferencia
                                                            de cuentas de
                                                            usuarios, en cuyo
                                                            caso exigiremos al
                                                            nuevo propietario
                                                            que continúe
                                                            respetando los
                                                            términos previstos
                                                            en esta Política de
                                                            Privacidad o
                                                            proporcionaremos a
                                                            la Escuela una
                                                            notificación y la
                                                            oportunidad de optar
                                                            por la transferencia
                                                            de los Datos
                                                            Personales de los
                                                            Estudiantes mediante
                                                            la eliminación de
                                                            las Cuentas o los
                                                            Datos Personales de
                                                            los Estudiantes
                                                            antes de que se
                                                            produzca la
                                                            transferencia.
                                                        </li>
                                                        <li>
                                                            No realizaremos
                                                            ningún cambio
                                                            sustancial en
                                                            nuestra Política de
                                                            Privacidad o en los
                                                            acuerdos
                                                            contractuales
                                                            relacionados con la
                                                            recopilación o el
                                                            uso de los Datos
                                                            Personales del
                                                            Estudiante sin
                                                            avisar primero a la
                                                            Escuela y ofrecerle
                                                            la posibilidad de
                                                            elegir antes de que
                                                            los Datos Personales
                                                            del Estudiante se
                                                            utilicen de una
                                                            manera materialmente
                                                            diferente a la que
                                                            se divulgó cuando se
                                                            recopilaron los
                                                            datos.
                                                        </li>
                                                    </ul>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cómo divulgamos los
                                                            datos personales de
                                                            los estudiantes
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Divulgamos los Datos
                                                        Personales de los
                                                        Estudiantes de la manera
                                                        descrita en nuestro
                                                        Aviso de Privacidad en
                                                        la sección titulada{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#sharing"
                                                        >
                                                            Divulgación de Datos
                                                        </Link>
                                                        . Además, en función de
                                                        las funciones y los
                                                        controles de cuenta
                                                        aplicables a las Cuentas
                                                        de la Escuela, podemos
                                                        divulgar información con
                                                        otros usuarios del
                                                        Servicio, como
                                                        profesores, entrenadores
                                                        o administradores de la
                                                        Escuela. Si un Usuario
                                                        de la Escuela publica
                                                        contenido en un foro de
                                                        la comunidad, su nombre
                                                        de usuario y los datos
                                                        de su perfil serán
                                                        visibles junto con el
                                                        comentario.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Dependiendo de la forma
                                                        en que Khan Academy sea
                                                        utilizada por una
                                                        Escuela y de los
                                                        términos del acuerdo
                                                        entre la Escuela y Khan
                                                        Academy, Khan Academy
                                                        puede proporcionar a la
                                                        Escuela acceso a ciertos
                                                        Datos Personales del
                                                        Estudiante, a la
                                                        información de uso de la
                                                        Cuenta de la Escuela y a
                                                        la información de uso de
                                                        la cuenta de usuario del
                                                        profesor para fines
                                                        escolares, como el
                                                        seguimiento de la
                                                        actividad de aprendizaje
                                                        de los estudiantes y la
                                                        evaluación de la
                                                        eficacia del uso del
                                                        Servicio por parte de la
                                                        Escuela. Khan Academy
                                                        también puede
                                                        proporcionar a las
                                                        Escuelas acceso a los
                                                        Datos Personales de los
                                                        Estudiantes, a la
                                                        información de uso de
                                                        los Estudiantes y a la
                                                        información de uso de
                                                        los profesores en
                                                        respuesta a una
                                                        solicitud de la Escuela.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            No hay publicidad
                                                            dirigida
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Khan Academy no utiliza,
                                                        divulga ni recopila los
                                                        Datos Personales de
                                                        Estudiantes de los
                                                        Usuarios de la Escuela
                                                        en el Servicio con el
                                                        fin de comercializar o
                                                        anunciar productos o
                                                        servicios comerciales,
                                                        incluida la publicidad
                                                        dirigida.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cómo conservamos y
                                                            eliminamos los Datos
                                                            Personales de los
                                                            Estudiante
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        No retendremos
                                                        conscientemente los
                                                        Datos Personales de los
                                                        Estudiantes más allá del
                                                        período de tiempo
                                                        necesario para apoyar un
                                                        propósito educativo, a
                                                        menos que la Escuela, el
                                                        estudiante o los padres
                                                        lo autoricen. Muchos de
                                                        nuestros usuarios siguen
                                                        utilizando sus cuentas
                                                        para un fin personal, no
                                                        escolar, y deciden
                                                        asociar sus cuentas a
                                                        una cuenta personal o a
                                                        la cuenta de sus padres.
                                                        En estos casos, el
                                                        usuario (o el padre del
                                                        usuario) es responsable
                                                        de las solicitudes de
                                                        eliminación de la
                                                        cuenta.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Los usuarios con cuentas
                                                        personales (o sus
                                                        Padres) pueden eliminar
                                                        sus cuentas y los datos
                                                        personales asociados a
                                                        la cuenta en cualquier
                                                        momento a través de la
                                                        Configuración de la
                                                        cuenta. Consulte: “
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://khanacademy.zendesk.com/hc/articles/202263014-How-can-I-cancel-or-delete-my-account-"
                                                        >
                                                            ¿Cómo puedo cancelar
                                                            o eliminar mi
                                                            cuenta?
                                                        </Link>
                                                        ” en el Centro de
                                                        Asistencia de Khan
                                                        Academy para obtener
                                                        instrucciones.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Dependiendo de la forma
                                                        en que Khan Academy sea
                                                        utilizada por una
                                                        Escuela y de los
                                                        términos de un acuerdo
                                                        entre la Escuela y Khan
                                                        Academy, los usuarios,
                                                        incluyendo los Usuarios
                                                        de la Escuela (o sus
                                                        Padres) pueden ser
                                                        capaces de eliminar sus
                                                        cuentas y los datos
                                                        personales asociados a
                                                        la cuenta a través de la
                                                        Configuración de la
                                                        cuenta. Consulte: “
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://khanacademy.zendesk.com/hc/articles/202263014-How-can-I-cancel-or-delete-my-account-"
                                                        >
                                                            ¿Cómo puedo cancelar
                                                            o eliminar mi
                                                            cuenta?
                                                        </Link>
                                                        ” en el Centro de
                                                        Asistencia de Khan
                                                        Academy para obtener
                                                        instrucciones. En
                                                        algunos casos (por
                                                        ejemplo, nuestro
                                                        servicio Distritos Khan
                                                        Academy, nuestros socios
                                                        escolares han
                                                        implementado Khan
                                                        Academy a partir de un
                                                        acuerdo entre Khan
                                                        Academy y el distrito
                                                        escolar o entidad
                                                        educativa que incluye
                                                        servicios
                                                        administrativos y de
                                                        registro adicionales; en
                                                        estos casos, es posible
                                                        que los usuarios
                                                        escolares (o sus padres)
                                                        no puedan eliminar las
                                                        cuentas a través de la
                                                        configuración de la
                                                        cuenta, y es posible que
                                                        las solicitudes de
                                                        eliminación deban
                                                        remitirse a la Escuela.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        La Escuela es
                                                        responsable de gestionar
                                                        los datos personales de
                                                        los estudiantes en las
                                                        cuentas que la escuela
                                                        ya no necesita para un
                                                        propósito educativo
                                                        mediante la presentación
                                                        de una solicitud de
                                                        eliminación. Los centros
                                                        escolares deben ponerse
                                                        en contacto con nuestro{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="mailto:schoolpartnerships@khanacademy.org"
                                                        >
                                                            Equipo de
                                                            Asociaciones
                                                            Escolares
                                                        </Link>{" "}
                                                        para solicitar la
                                                        eliminación de los Datos
                                                        Personales de
                                                        Estudiantes asociados a
                                                        las cuentas escolares.
                                                        Es posible que le
                                                        pidamos más información
                                                        para verificar la
                                                        autenticidad de una
                                                        solicitud de
                                                        eliminación. Si un
                                                        usuario escolar ha
                                                        asociado su cuenta
                                                        escolar a una cuenta
                                                        personal, la actividad
                                                        de aprendizaje del
                                                        usuario escolar puede
                                                        conservarse en la cuenta
                                                        personal.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Preguntas sobre los
                                                            datos personales de
                                                            los estudiantes
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Si tiene preguntas sobre
                                                        prácticas específicas
                                                        relacionadas con los
                                                        Datos Personales de
                                                        Estudiantes
                                                        proporcionados a Khan
                                                        Academy por una Escuela,
                                                        por favor dirija sus
                                                        preguntas a su Escuela.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Esta sección no se
                                                        aplica a la información
                                                        que un estudiante u otro
                                                        individuo pueda
                                                        proporcionar a Khan
                                                        Academy
                                                        independientemente del
                                                        uso del Servicio por
                                                        parte del estudiante
                                                        bajo la dirección de la
                                                        Escuela. Por ejemplo, si
                                                        un usuario vincula su
                                                        cuenta personal
                                                        existente a su Cuenta de
                                                        la Escuela, o elige
                                                        conservar su actividad
                                                        de aprendizaje de Khan
                                                        Academy en una cuenta
                                                        personal, la información
                                                        asociada a la cuenta
                                                        personal no se considera
                                                        Datos Personales del
                                                        Estudiante.
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="childrens-privacy"
                                    className={css(styles.sectionTitle)}
                                >
                                    Aviso de Privacidad para Menores
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso de privacidad complementa nuestra
                                    Política de Privacidad y proporciona
                                    información adicional sobre cómo
                                    recopilamos, utilizamos y divulgamos la
                                    información personal de los menores de 13
                                    años (un "<strong>Menor</strong>" o "
                                    <strong>Menores</strong>”).
                                </p>
                                <p className={css(styles.paragraph)}>
                                    <strong>
                                        Khan Academy está comprometida con la
                                        privacidad de los menores.
                                    </strong>
                                </p>
                                <p className={css(styles.paragraph)}>
                                    La protección de la privacidad de los
                                    menores es especialmente importante para
                                    Khan Academy. Por esa razón, hemos creado
                                    ciertas características diseñadas para
                                    ayudar a proteger los datos personales de
                                    los menores ("
                                    <strong>Usuarios Menores</strong>"). Cuando
                                    un menor crea una cuenta, recopilamos su
                                    información en cumplimiento con las leyes
                                    aplicables, incluso solicitamos el
                                    consentimiento de un padre o tutor legal ("
                                    <strong>Padre</strong>") para crear dicha
                                    cuenta. Cuando Khan Academy es utilizado por
                                    una escuela en un entorno educativo,
                                    confiamos en que la escuela proporcione el
                                    consentimiento necesario, en nombre de los
                                    padres, para que Khan Academy recopile datos
                                    de un usuario escolar menor de 13 años para
                                    fines educacionales.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Revise “Información Adicional” para obtener
                                    más información acerca de:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        De qué manera los Menores pueden usar y
                                        registrarse en nuestro Servicio
                                    </li>
                                    <li>
                                        Las restricciones impuestas a las
                                        cuentas de los Usuarios Menores
                                    </li>
                                    <li>
                                        Los datos recopilados y cómo se utiliza
                                        dichos datos
                                    </li>
                                    <li>Datos divulgados</li>
                                    <li>
                                        Ausencia de seguimiento por parte de
                                        terceros y de publicidad dirigida
                                    </li>
                                    <li>
                                        Elección: Acceder, modificar y eliminar
                                        las cuentas de los menores
                                    </li>
                                </ul>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(8)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[8]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[8] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cómo pueden utilizar
                                                            los menores nuestro
                                                            Servicio y
                                                            registrarse en él
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Los usuarios pueden ver
                                                        nuestro contenido y
                                                        hacer ejercicios sin
                                                        crear una cuenta. Sin
                                                        embargo, la
                                                        funcionalidad está
                                                        limitada si los usuarios
                                                        no crean una cuenta.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Khan Academy no permite
                                                        a sus usuarios menores
                                                        de edad crear una cuenta
                                                        sin el consentimiento de
                                                        los padres o de la
                                                        escuela. Si Khan Academy
                                                        se entera de que se han
                                                        recopilado datos
                                                        personales de un Usuario
                                                        Menor en nuestro
                                                        Servicio sin el
                                                        consentimiento de los
                                                        padres o de la escuela,
                                                        Khan Academy tomará las
                                                        medidas adecuadas para
                                                        eliminar esta
                                                        información. Si usted es
                                                        un padre y descubre que
                                                        su hijo menor de 13 años
                                                        tiene una cuenta
                                                        personal registrada en
                                                        nuestro Servicio sin
                                                        consentimiento, diríjase
                                                        a{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#contact"
                                                        >
                                                            Contacto con Khan
                                                            Academy
                                                        </Link>{" "}
                                                        y solicite que
                                                        eliminemos de nuestros
                                                        sistemas los datos
                                                        personales de ese menor.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Los Usuarios Menores
                                                        pueden registrarse en
                                                        una cuenta de Khan
                                                        Academy de una de las
                                                        siguientes maneras:
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Un Usuario Menor
                                                            puede inscribirse en
                                                            una cuenta de Khan
                                                            Academy con el
                                                            consentimiento de
                                                            sus padres
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Cuando un Usuario Menor
                                                        se registra en nuestro
                                                        Servicio, solicitamos un
                                                        nombre de usuario, una
                                                        fecha de nacimiento, una
                                                        contraseña y una
                                                        dirección de correo
                                                        electrónico de los
                                                        padres para poder enviar
                                                        un correo electrónico a
                                                        los padres del Usuario
                                                        Menor con el fin de
                                                        solicitar el
                                                        consentimiento para que
                                                        el menor utilice el
                                                        Servicio. Khan Academy
                                                        no solicita al Usuario
                                                        Menor más datos que los
                                                        necesarios para prestar
                                                        el Servicio al Usuario
                                                        Menor o para solicitar
                                                        el consentimiento de los
                                                        padres. El Usuario Menor
                                                        está autorizado a
                                                        utilizar el Servicio
                                                        durante 7 días a través
                                                        de una{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#restricted"
                                                            style={{
                                                                fontWeight:
                                                                    "bold",
                                                            }}
                                                        >
                                                            Cuenta Limitada
                                                        </Link>{" "}
                                                        mientras notificamos a
                                                        los padres y solicitamos
                                                        su consentimiento. Si no
                                                        recibimos el
                                                        consentimiento de los
                                                        padres en un plazo de 7
                                                        días, la cuenta limitada
                                                        del usuario menor se
                                                        cierra y los datos
                                                        personales del menor se
                                                        eliminan de nuestros
                                                        sistemas. Khan Academy
                                                        puede confiar en que una
                                                        escuela proporcione el
                                                        consentimiento en nombre
                                                        de un padre, como se
                                                        describe a continuación.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cuando una escuela
                                                            crea una cuenta de
                                                            usuario para un
                                                            menor, confiamos en
                                                            la escuela para que
                                                            dé su consentimiento
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Cuando una escuela
                                                        utiliza el Servicio de
                                                        Khan Academy en un
                                                        entorno educativo,
                                                        permitimos que la
                                                        escuela cree cuentas de
                                                        usuario menor y
                                                        proporcione el
                                                        consentimiento
                                                        necesario, en lugar de
                                                        los padres del usuario
                                                        menor, para que Khan
                                                        Academy recopile los
                                                        datos personales de un
                                                        usuario menor para este
                                                        fin. Las escuelas pueden
                                                        crear una cuenta de
                                                        usuario menor añadiendo
                                                        estudiantes al Servicio
                                                        a través de Google
                                                        Classroom, Clever o un
                                                        servicio similar de
                                                        inicio de sesión único,
                                                        proporcionando un enlace
                                                        o código de clase para
                                                        unirse a una clase, o
                                                        una escuela puede crear
                                                        inicios de sesión y
                                                        contraseñas para cada
                                                        estudiante individual.
                                                        Cuando las escuelas
                                                        crean cuentas de esta
                                                        manera, confiamos en el
                                                        consentimiento que nos
                                                        proporciona la escuela y
                                                        no requerimos un
                                                        consentimiento adicional
                                                        de los padres.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Métodos para
                                                            proporcionar el
                                                            consentimiento de
                                                            los padres
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Los padres pueden dar su
                                                        consentimiento para que
                                                        un Usuario Menor utilice
                                                        el Servicio a través de
                                                        una Cuenta limitada
                                                        respondiendo
                                                        afirmativamente a un
                                                        correo electrónico
                                                        enviado por Khan Academy
                                                        a la dirección de correo
                                                        electrónico de los
                                                        padres proporcionada por
                                                        el Usuario Menor durante
                                                        el registro. Si no
                                                        recibimos el
                                                        consentimiento de los
                                                        padres (o la
                                                        confirmación de que la
                                                        cuenta es una cuenta
                                                        escolar) en un plazo de
                                                        7 días, la cuenta del
                                                        usuario infantil se
                                                        cerrará y los datos
                                                        personales del niño se
                                                        eliminarán de nuestros
                                                        sistemas. Las cuentas
                                                        limitadas pueden acceder
                                                        y utilizar determinadas
                                                        funciones del Servicio
                                                        de forma limitada.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cuentas de los
                                                            padres
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para habilitar
                                                        funcionalidades
                                                        adicionales para la
                                                        cuenta del Usuario Menor
                                                        y para permitir el
                                                        acceso y control total
                                                        sobre la actividad de la
                                                        cuenta del Usuario
                                                        Menor, el Padre debe
                                                        crear una "Cuenta de los
                                                        padres" en el Servicio y
                                                        conectarse a la cuenta
                                                        del Usuario Menor
                                                        haciendo clic en el
                                                        enlace de creación de la
                                                        cuenta en el aviso de
                                                        consentimiento de los
                                                        padres. Las cuentas de
                                                        los padres controlan la
                                                        configuración y la
                                                        funcionalidad de la
                                                        cuenta del usuario
                                                        menor. Los padres pueden
                                                        mantener la cuenta
                                                        limitada del menor y, si
                                                        lo desean, pueden
                                                        habilitar funciones y
                                                        características
                                                        adicionales de la
                                                        cuenta. Los padres
                                                        pueden revocar los
                                                        permisos de un usuario
                                                        menor para utilizar el
                                                        Servicio en cualquier
                                                        momento eliminando la
                                                        cuenta. En algunos
                                                        casos, los controles
                                                        administrativos,
                                                        incluida la capacidad de
                                                        modificar o eliminar la
                                                        cuenta, están en manos
                                                        de la Escuela.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        id="restricted"
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cuentas limitadas
                                                            para usuarios
                                                            menores
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Khan Academy intenta
                                                        limitar el acceso de un
                                                        Usuario Menor a ciertas
                                                        funciones que podrían
                                                        dar lugar a la
                                                        divulgación de los datos
                                                        personales del menor.
                                                        Una Cuenta Limitada
                                                        limita el compartir y
                                                        mostrar información
                                                        privada sobre el Usuario
                                                        Menor de varias maneras.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Por ejemplo, un Usuario
                                                        Menor con una Cuenta
                                                        Limitada no puede:
                                                    </p>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            Mostrar datos
                                                            personales que no
                                                            sean un nombre de
                                                            usuario. Las Cuentas
                                                            Limitadas contienen
                                                            el nombre de usuario
                                                            del Menor y no
                                                            incluyen otra
                                                            información personal
                                                            o de perfil. Dado
                                                            que el nombre de
                                                            usuario puede
                                                            mostrarse en el
                                                            Servicio,
                                                            recomendamos
                                                            encarecidamente
                                                            seleccionar un
                                                            nombre de usuario
                                                            que no se relacione
                                                            con el nombre real
                                                            del Menor ni lo
                                                            identifique. El
                                                            nombre de usuario
                                                            del Menor puede ser
                                                            seleccionado o
                                                            revisado por el
                                                            Padre creando una
                                                            Cuenta de Padre.
                                                        </li>
                                                        <li>
                                                            Añadir o editar los
                                                            datos personales
                                                            asociados a una
                                                            Cuenta Limitada.
                                                        </li>
                                                        <li>
                                                            Publicar en los
                                                            foros públicos de la
                                                            comunidad, o
                                                            publicar preguntas o
                                                            respuestas en las
                                                            lecciones.
                                                        </li>
                                                        <li>
                                                            Recibir mensajes de
                                                            correo electrónico
                                                            de Khan Academy
                                                            (todos los correos
                                                            electrónicos se
                                                            envían al correo
                                                            electrónico de los
                                                            padres registrado).
                                                        </li>
                                                        <li>
                                                            Comunicarse o
                                                            divulgar datos
                                                            personales a los
                                                            Entrenadores que no
                                                            sean un nombre de
                                                            usuario y la
                                                            actividad de uso del
                                                            Servicio (es decir,
                                                            lecciones
                                                            completadas,
                                                            insignias obtenidas,
                                                            interacciones con
                                                            Khanmigo, actividad
                                                            de aprendizaje,
                                                            etc.). Del mismo
                                                            modo, los
                                                            Entrenadores no
                                                            pueden comunicarse
                                                            con un Usuario Menor
                                                            con una Cuenta
                                                            Limitada, excepto
                                                            para asignar
                                                            contenido para el
                                                            Usuario Menor.
                                                        </li>
                                                    </ul>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Qué datos
                                                            recopilamos de un
                                                            Usuario Menor y cómo
                                                            los utilizamos
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Cuando se registra en el
                                                        Servicio un Usuario
                                                        Menor, recopilamos un
                                                        nombre de usuario, fecha
                                                        de nacimiento y la
                                                        dirección de correo
                                                        electrónico de los
                                                        padres, así como
                                                        cualquier otro dato
                                                        personal que los padres
                                                        añadan a la cuenta del
                                                        Usuario Menor, tal y
                                                        como se ha descrito
                                                        anteriormente.
                                                        Recopilamos información
                                                        sobre el uso del
                                                        Servicio por parte del
                                                        Usuario Menor (lecciones
                                                        completadas, insignias
                                                        obtenidas). También
                                                        recopilamos información
                                                        sobre el uso y el
                                                        dispositivo, tal y como
                                                        se describe en{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#collection-info"
                                                        >
                                                            Recopilación de
                                                            Información
                                                        </Link>
                                                        .
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Utilizamos la
                                                        información recopilada
                                                        sobre los Usuarios
                                                        Menores para
                                                        proporcionar los
                                                        Servicios, personalizar
                                                        su experiencia con
                                                        contenido apropiado y
                                                        atractivo, comunicarse
                                                        con ellos, mejorar
                                                        nuestros servicios,
                                                        desarrollar nuevas
                                                        ofertas, y para proteger
                                                        la seguridad de nuestros
                                                        usuarios y cumplir con
                                                        los requisitos legales.
                                                        Para obtener más
                                                        información sobre cómo
                                                        utilizamos la
                                                        información sobre los
                                                        Usuarios Menores,
                                                        consulte nuestra
                                                        descripción en{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#use-of-info"
                                                        >
                                                            Uso de los Datos
                                                        </Link>
                                                        . Utilizamos la
                                                        dirección de correo
                                                        electrónico de los
                                                        padres para comunicarles
                                                        mensajes sobre la
                                                        cuenta.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cómo revelamos los
                                                            datos relativos a un
                                                            Usuario Menor
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Como se ha descrito
                                                        anteriormente, las
                                                        Cuentas Limitadas tienen
                                                        una capacidad limitada
                                                        para compartir sus
                                                        datos. El nombre de
                                                        usuario y la información
                                                        de progreso, junto con
                                                        cualquier dato personal
                                                        que el padre haya
                                                        añadido al perfil del
                                                        menor, se divulga a un
                                                        entrenador o profesor
                                                        añadido a la cuenta del
                                                        Usuario Menor, aunque
                                                        una Cuenta de Padres
                                                        puede limitar al Usuario
                                                        Menor la posibilidad de
                                                        añadir entrenadores a la
                                                        cuenta. Los padres
                                                        también pueden habilitar
                                                        funciones adicionales
                                                        para compartir los datos
                                                        a través de una cuenta
                                                        de padres, por ejemplo,
                                                        añadiendo información de
                                                        perfil y permitiendo que
                                                        el perfil se divulgue a
                                                        los entrenadores y otros
                                                        usuarios, o permitiendo
                                                        que el Usuario Menor
                                                        publique contenidos (por
                                                        ejemplo, preguntas y
                                                        respuestas) en el
                                                        Servicio. Los padres que
                                                        habiliten las funciones
                                                        de publicación de
                                                        contenidos deben ser
                                                        conscientes de que un
                                                        Usuario Menor podría
                                                        publicar datos de
                                                        identificación personal
                                                        en contenidos de formato
                                                        libre en el Servicio, y
                                                        deben supervisar las
                                                        publicaciones del
                                                        Usuario Menor y eliminar
                                                        los datos personales si
                                                        es necesario. También
                                                        podemos revelar
                                                        información personal de
                                                        los Usuarios Menores por
                                                        razones legales,
                                                        cumplimiento y de
                                                        seguridad, como se
                                                        describe en{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#sharing"
                                                        >
                                                            Divulgación de datos
                                                        </Link>
                                                        .
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Sin seguimiento de
                                                            terceros y sin
                                                            publicidad dirigida
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Khan Academy no muestra
                                                        ninguna publicidad
                                                        dirigida en el Servicio.
                                                        No divulgamos los datos
                                                        personales de los
                                                        Usuarios Menores para
                                                        fines de
                                                        comercialización directa
                                                        o para fines de
                                                        publicidad dirigida.
                                                        Además, tomamos medidas
                                                        para desactivar las
                                                        redes publicitarias de
                                                        terceros en las páginas
                                                        web con contenido.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Cómo acceder,
                                                            modificar y eliminar
                                                            las Cuentas de sus
                                                            Hijos
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Como padre, tiene la
                                                        posibilidad de acceder y
                                                        controlar la información
                                                        de su Usuario Menor en
                                                        la sección "Sus hijos"
                                                        de su Cuenta de Padre.
                                                        Para rechazar la
                                                        recopilación o el uso
                                                        futuro de los datos
                                                        personales de su hijo,
                                                        puede eliminar la cuenta
                                                        de su Usuario Menor
                                                        siguiendo las
                                                        instrucciones de
                                                        nuestras{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://khanacademy.zendesk.com/hc/articles/202263014"
                                                        >
                                                            Preguntas Frecuentes
                                                        </Link>
                                                        . Tenga en cuenta que
                                                        debe eliminar su cuenta
                                                        de Usuario Menor antes
                                                        de eliminar la Cuenta de
                                                        Padre.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Si no tiene una Cuenta
                                                        de Padres asociada a la
                                                        Cuenta Limitada de su
                                                        Usuario Menor, puede
                                                        ponerse en contacto con
                                                        nosotros en nuestra{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://support.khanacademy.org/hc/requests/new"
                                                        >
                                                            Página de Asistencia
                                                            page
                                                        </Link>{" "}
                                                        para acceder o eliminar
                                                        la cuenta del Usuario
                                                        Menor. Tenga en cuenta
                                                        que necesitará el nombre
                                                        de usuario del Usuario
                                                        Menor, y es posible que
                                                        tomemos medidas para
                                                        autenticar su identidad
                                                        antes de poder
                                                        proporcionarle acceso a
                                                        la Cuenta Limitada.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        En algunos casos, los
                                                        controles
                                                        administrativos,
                                                        incluida la capacidad de
                                                        modificar o eliminar la
                                                        cuenta, están en manos
                                                        de la Escuela y usted
                                                        tendrá que dirigir su
                                                        solicitud a la Escuela.
                                                        Para más información,
                                                        consulte{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#schools"
                                                        >
                                                            Uso por parte de
                                                            Escuelas y
                                                            Estudiantes
                                                        </Link>
                                                        .
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="donor-info"
                                    className={css(styles.sectionTitle)}
                                >
                                    Información de donadores
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso sobre la información de donadores
                                    complementa nuestra Política de Privacidad
                                    en relación con los donadores. Si usted dona
                                    a Khan Academy y no lo hace de forma
                                    anónima, obtenemos datos como su nombre,
                                    dirección de correo electrónico y dirección
                                    postal. Si usted dona utilizando nuestro
                                    formulario en línea, nuestro procesador de
                                    pagos también recopilará su número de
                                    tarjeta de crédito o débito u otra
                                    información de pago.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Tenga en cuenta que la información
                                    recopilada por estos procesadores de pagos
                                    está sujeta a sus propios avisos de
                                    privacidad.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Podemos utilizar los datos de los donadores
                                    para comunicarnos con usted en relación con
                                    su contribución y para enviarle información
                                    actualizada sobre la recaudación de fondos y
                                    el avance de nuestra misión.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    No divulgamos los datos personales de los
                                    donadores, salvo con su consentimiento o
                                    según lo exija la ley.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Si se ha registrado para obtener una cuenta
                                    con nosotros, puede actualizar sus
                                    preferencias en la configuración de su
                                    cuenta para optar por no recibir correos
                                    electrónicos de los donadores. Si no tiene
                                    una cuenta con nosotros, puede optar por no
                                    recibirlos haciendo clic en el enlace de
                                    cancelación de la suscripción que aparece en
                                    el mensaje de correo electrónico del donador
                                    o respondiendo al correo electrónico para
                                    solicitar su eliminación. Tenga en cuenta
                                    que si se ha dado de baja pero
                                    posteriormente realiza una donación (o
                                    asiste a un evento para donadores), es
                                    posible que le enviemos comunicaciones de
                                    seguimiento en relación con su apoyo a
                                    nuestra misión.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(9)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[9]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[9] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Nuestros compromisos
                                                        </strong>
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            No venderemos,
                                                            compartiremos o
                                                            intercambiaremos los
                                                            nombres o los datos
                                                            personales de
                                                            nuestros donadores
                                                            con ninguna otra
                                                            entidad.
                                                        </li>
                                                        <li>
                                                            No enviaremos
                                                            correos a nuestros
                                                            donadores en nombre
                                                            de otras
                                                            organizaciones.
                                                        </li>
                                                        <li>
                                                            Recopilaremos la
                                                            información de pago,
                                                            la dirección de
                                                            facturación y otros
                                                            datos necesarios
                                                            para procesar una
                                                            donación o la
                                                            inscripción a un
                                                            evento.
                                                        </li>
                                                        <li>
                                                            Utilizaremos sus
                                                            datos para cumplir
                                                            con la ley o en la
                                                            creencia de buena fe
                                                            de que dicha acción
                                                            es necesaria para
                                                            cumplir con los
                                                            requisitos de la ley
                                                            o cumplir con el
                                                            proceso legal que se
                                                            nos ha notificado.
                                                        </li>
                                                        <li>
                                                            Podremos utilizar
                                                            los datos personales
                                                            para protegernos de
                                                            posibles fraudes.
                                                            Podemos verificar
                                                            con terceros la
                                                            información
                                                            recopilada en el
                                                            curso de la
                                                            tramitación de un
                                                            regalo, la
                                                            inscripción en un
                                                            evento u otra
                                                            donación.
                                                        </li>
                                                        <li>
                                                            Si utiliza una
                                                            tarjeta de crédito o
                                                            débito en el sitio
                                                            web, podemos
                                                            utilizar servicios
                                                            de autorización de
                                                            tarjetas y de
                                                            detección de fraudes
                                                            para verificar que
                                                            los datos de su
                                                            tarjeta y su
                                                            dirección coinciden
                                                            con la información
                                                            que nos ha
                                                            facilitado y que la
                                                            tarjeta que se
                                                            utiliza no ha sido
                                                            declarada perdida o
                                                            robada.
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <h2
                                    id="paid-products"
                                    className={css(styles.sectionTitle)}
                                >
                                    Productos de pago
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso sobre productos de pago
                                    complementa nuestro Aviso de Privacidad en
                                    relación con productos de pago. Si adquiere
                                    una suscripción de pago a un servicio de
                                    Khan Academy, como Khanmigo, obtenemos
                                    información como su nombre, dirección de
                                    correo electrónico y dirección postal, y
                                    nuestro procesador de pagos también
                                    recopilará su número de tarjeta de crédito o
                                    débito u otra información de pago. Tenga en
                                    cuenta que la información recopilada por
                                    estos procesadores de pago está sujeta a su
                                    propio aviso de privacidad.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Podemos utilizar esta información para
                                    gestionar los servicios que recibe y para
                                    comunicarnos con usted sobre su suscripción.
                                </p>
                                <h2
                                    id="applicant"
                                    className={css(styles.sectionTitle)}
                                >
                                    Información para Solicitantes
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso de Información para Solicitantes
                                    complementa nuestro Aviso de Privacidad en
                                    relación con los solicitantes. Si usted
                                    solicita un puesto de trabajo en Khan
                                    Academy a través de una solicitud en línea o
                                    un sitio de reclutamiento, obtendremos la
                                    información que usted decida proporcionar en
                                    su solicitud para ese fin. Por ejemplo,
                                    recopilamos información profesional o
                                    relacionada con el empleo que suele incluir
                                    detalles sobre su historial de empleo,
                                    experiencia y calificaciones; así como
                                    información sobre la educación, incluidos
                                    los títulos obtenidos y los registros
                                    académicos.
                                </p>
                                <h2
                                    id="regional-info"
                                    className={css(styles.sectionTitle)}
                                >
                                    Información Regional
                                </h2>
                                <p className={css(styles.paragraph)}>
                                    Este aviso de Información Regional
                                    complementa nuestro Aviso de Privacidad.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Las prácticas de privacidad de Khan Academy
                                    están diseñadas para respaldar los derechos
                                    y expectativas de privacidad de los
                                    consumidores a nivel global, incluyendo los
                                    derechos de privacidad comunes en muchos
                                    países donde nuestros Servicios están
                                    disponibles y que pueden ser aplicables a
                                    usted. Estos derechos incluyen:
                                </p>
                                <ul className={css(styles.list)}>
                                    <li>
                                        El derecho a entender qué información
                                        personal recopilamos, cómo la usamos,
                                        cómo se trata, almacena y protege, con
                                        quién se comparte y si se vende.
                                    </li>
                                    <li>
                                        El derecho a corregir su información
                                        personal.
                                    </li>
                                    <li>
                                        El derecho a solicitar que su
                                        información personal sea eliminada o
                                        anonimizada.
                                    </li>
                                    <li>
                                        El derecho a oponerse a cómo y por qué
                                        se usa o trata su información personal,
                                        incluyendo la opción de excluirle de la
                                        venta de información personal.
                                    </li>
                                    <li>
                                        El derecho a retirar el consentimiento
                                        para el tratamiento.
                                    </li>
                                    <li>
                                        El derecho a presentar una queja ante la
                                        autoridad de supervisión
                                        correspondiente.
                                    </li>
                                    <li>
                                        El derecho a no sufrir discriminación
                                        por ejercer sus derechos de privacidad.
                                    </li>
                                </ul>
                                <p className={css(styles.paragraph)}>
                                    Los derechos de privacidad específicos y los
                                    procesos para ejercerlos varían de un país a
                                    otro. En ciertas regiones, puede tener
                                    derechos adicionales.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    La descripción de estos derechos, así como
                                    los procesos y procedimientos para
                                    ejercerlos, varían y, en algunos casos, los
                                    derechos deben procesarse dentro de plazos
                                    específicos. Podemos requerir que usted, o
                                    su representante legal, establezca
                                    adecuadamente su identidad antes de actuar
                                    sobre su solicitud. Es imperativo que
                                    proporcione toda la información solicitada
                                    de manera oportuna (según lo establecido por
                                    sus regulaciones locales) para cumplir con
                                    los requisitos aplicables.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Si desea ejercer un derecho de privacidad,
                                    diríjase a{" "}
                                    <Link inline={true} href="#contact">
                                        Contacto con Khan Academy
                                    </Link>
                                    . Nuestra capacidad para responder a
                                    solicitudes específicas puede estar limitada
                                    por la legislación aplicable y la
                                    funcionalidad de nuestro Servicio. Por
                                    ejemplo, podremos necesitar algunos datos
                                    personales para fines legítimos de negocio,
                                    o porque el tratamiento es necesario para
                                    proporcionar los servicios que requirió.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    Podemos proporcionar información adicional
                                    complementaria con respecto a la prestación
                                    de nuestros Servicios en ciertas regiones o
                                    en relación con programas específicos que
                                    ofrecemos fuera de los Estados Unidos,
                                    incluso en la página{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="https://khanacademy.zendesk.com/hc/es"
                                    >
                                        Centro de Asistencia de Khan Academy
                                    </Link>{" "}
                                    o en sitios web regionales.
                                </p>
                                <p className={css(styles.paragraph)}>
                                    <strong>
                                        Transferencia internacional de datos:
                                    </strong>
                                    Nuestro Servicio es operado y administrado
                                    en servidores ubicados dentro de los Estados
                                    Unidos. Si usted decide utilizar nuestro
                                    Servicio desde Europa u otras regiones del
                                    mundo con leyes que rigen la recopilación y
                                    el uso de datos que difieren de la
                                    legislación de los Estados Unidos, entonces
                                    usted reconoce y está de acuerdo que Khan
                                    Academy transferirá, almacenará y procesará
                                    sus datos personales a los Estados Unidos
                                    con el fin de llevar a cabo el Servicio de
                                    acuerdo con nuestro contrato (por ejemplo,
                                    nuestros{" "}
                                    <Link
                                        target="_blank"
                                        inline={true}
                                        href="/about/docs/khan-academy-terms-of-service"
                                    >
                                        Términos de Servicio
                                    </Link>
                                    ) y para cualquier otro propósito para el
                                    que usted proporcione un consentimiento
                                    explícito e informado.
                                </p>
                                <table className={css(styles.learnMoreTable)}>
                                    <tbody>
                                        <tr>
                                            <td
                                                onClick={() =>
                                                    this.toggleLearnMore(10)
                                                }
                                                className={css(
                                                    styles.learnMoreHeaderContainer,
                                                )}
                                            >
                                                <h3
                                                    className={css(
                                                        styles.learnMoreHeader,
                                                    )}
                                                >
                                                    Información Adicional
                                                </h3>
                                                <PhosphorIcon
                                                    icon={caretDownIcon}
                                                    color={color.offBlack}
                                                    size="small"
                                                    style={{
                                                        margin: "2%",
                                                        transition: `transform 0.3s`,
                                                        transform: `rotate(${
                                                            this.state
                                                                .learnMoreOpen[10]
                                                                ? "-180deg"
                                                                : "0deg"
                                                        })`,
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        {this.state.learnMoreOpen[10] && (
                                            <tr
                                                className={css(
                                                    styles.learnMoreTableContents,
                                                )}
                                            >
                                                <td
                                                    className={css(
                                                        styles.learnMoreTableData,
                                                    )}
                                                >
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Disposiciones
                                                            específicas para
                                                            residentes en México
                                                        </strong>
                                                    </h4>
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Si usted es residente en
                                                        México, se incluyen las
                                                        siguientes disposiciones
                                                        en cumplimiento a la Ley
                                                        Federal de Protección de
                                                        Datos Personales en
                                                        Posesión de los
                                                        Particulares, su
                                                        Reglamento y los
                                                        Lineamientos del Aviso
                                                        de Privacidad:
                                                    </p>
                                                    <br />
                                                    <ol
                                                        className={css(
                                                            styles.orderedList,
                                                        )}
                                                    >
                                                        <li>
                                                            <p
                                                                className={css(
                                                                    styles.paragraph,
                                                                )}
                                                            >
                                                                Recopilamos su
                                                                información
                                                                personal con el
                                                                fin principal de
                                                                crear, mantener
                                                                y cumplir
                                                                nuestras
                                                                obligaciones
                                                                legales con
                                                                usted, en el
                                                                contexto de la
                                                                relación entre
                                                                Khan Academy,
                                                                como responsable
                                                                del tratamiento
                                                                de datos, y
                                                                usted, como
                                                                Titular. A menos
                                                                que se indique a
                                                                continuación,
                                                                todos los demás
                                                                fines enumerados
                                                                en la sección
                                                                "Uso de los
                                                                Datos" se
                                                                consideran
                                                                primarios.
                                                            </p>
                                                            <p
                                                                className={css(
                                                                    styles.paragraph,
                                                                )}
                                                            >
                                                                Las siguientes
                                                                finalidades se
                                                                consideran
                                                                secundarias y,
                                                                si lo desea,
                                                                puede oponerse a
                                                                ellas utilizando
                                                                los medios
                                                                establecidos en
                                                                el párrafo 4
                                                                abajo:
                                                                Comunicarnos con
                                                                usted sobre su
                                                                cuenta y nuestro
                                                                Servicio
                                                                (únicamente para
                                                                el intercambio
                                                                de información
                                                                sobre nuevas
                                                                funciones y
                                                                ofertas que
                                                                puedan ser de su
                                                                interés). Usted
                                                                puede manejar la
                                                                configuración de
                                                                su suscripción
                                                                de correo
                                                                electrónico
                                                                haciendo clic en
                                                                el enlace al
                                                                final del correo
                                                                que le enviamos
                                                                o desde la
                                                                página de
                                                                Configuración de
                                                                su cuenta.
                                                            </p>
                                                        </li>
                                                        <li>
                                                            <p
                                                                className={css(
                                                                    styles.paragraph,
                                                                )}
                                                            >
                                                                Además de las
                                                                transferencias
                                                                enumeradas en la
                                                                sección
                                                                "Divulgación de
                                                                información" en
                                                                las que se
                                                                indica
                                                                expresamente que
                                                                se requiere su
                                                                consentimiento,
                                                                las siguientes
                                                                transferencias
                                                                de datos pueden
                                                                requerir de su
                                                                consentimiento:
                                                            </p>
                                                            <ul
                                                                className={css(
                                                                    styles.subList,
                                                                )}
                                                            >
                                                                <li>
                                                                    con otros
                                                                    usuarios que
                                                                    estén
                                                                    asociados a
                                                                    su cuenta,
                                                                    como padres
                                                                    (en el caso
                                                                    de mayores
                                                                    de edad),
                                                                    profesores o
                                                                    entrenadores.
                                                                </li>
                                                                <li>
                                                                    en relación
                                                                    con
                                                                    transferencias
                                                                    empresariales
                                                                    (debidas a
                                                                    fusiones y
                                                                    adquisiciones).
                                                                </li>
                                                            </ul>
                                                            <br />
                                                            <p
                                                                className={css(
                                                                    styles.paragraph,
                                                                )}
                                                            >
                                                                Cláusula de
                                                                consentimiento:
                                                                al suscribirse y
                                                                utilizar los
                                                                Servicios, así
                                                                como al dar su
                                                                consentimiento a
                                                                este Aviso de
                                                                Privacidad,
                                                                usted acepta
                                                                expresamente las
                                                                transferencias
                                                                incluidas en la
                                                                sección
                                                                "Divulgación de
                                                                información" y
                                                                en este Addendum
                                                                que puedan
                                                                requerir de su
                                                                consentimiento.
                                                            </p>
                                                        </li>
                                                        <li>
                                                            Usted podrá oponerse
                                                            al tratamiento de
                                                            sus datos personales
                                                            poniéndose en
                                                            contacto con Khan
                                                            Academy a través de
                                                            los datos de
                                                            contacto
                                                            proporcionados en el
                                                            aviso de privacidad.
                                                            Si el aviso de
                                                            privacidad no le fue
                                                            entregado o puesto a
                                                            su disposición
                                                            directa o
                                                            personalmente, usted
                                                            cuenta con un plazo
                                                            de cinco días
                                                            hábiles para
                                                            oponerse a que
                                                            utilicemos sus datos
                                                            personales para
                                                            fines que no sean
                                                            indispensables o que
                                                            no hayan contribuido
                                                            al establecimiento
                                                            de nuestra relación
                                                            jurídica. Aunque no
                                                            se oponga al uso de
                                                            sus datos personales
                                                            antes de que los
                                                            recibamos o
                                                            utilicemos, se
                                                            mantendrán sus
                                                            derechos a revocar
                                                            su consentimiento u
                                                            oponerse al
                                                            tratamiento en
                                                            cualquier momento.
                                                        </li>
                                                        <li>
                                                            Usted o su
                                                            representante legal
                                                            podrán ejercer sus
                                                            derechos de acceso,
                                                            rectificación,
                                                            cancelación u
                                                            oposición (en lo
                                                            sucesivo "Derechos
                                                            ARCO"), así como
                                                            revocar su
                                                            consentimiento para
                                                            el tratamiento de
                                                            sus datos
                                                            personales,
                                                            poniéndose en
                                                            contacto con Khan
                                                            Academy a través de
                                                            los datos de
                                                            contacto
                                                            proporcionados en el
                                                            aviso de privacidad,
                                                            y su solicitud será
                                                            atendida en tiempo y
                                                            forma. Es posible
                                                            que le solicitemos a
                                                            usted, o a su
                                                            representante legal,
                                                            que acredite
                                                            debidamente su
                                                            identidad antes de
                                                            dar curso a su
                                                            solicitud. Por lo
                                                            tanto, es importante
                                                            que facilite toda la
                                                            información
                                                            solicitada y que
                                                            incluya una copia de
                                                            un documento de
                                                            identidad oficial
                                                            vigente. Si la
                                                            información que
                                                            facilita es
                                                            incorrecta o
                                                            insuficiente, o si
                                                            no se incluyen los
                                                            documentos de
                                                            identificación
                                                            necesarios, podremos
                                                            solicitarle, en un
                                                            plazo de cinco (5)
                                                            días hábiles a
                                                            partir de la
                                                            recepción de su
                                                            solicitud, que
                                                            facilite la
                                                            información o los
                                                            documentos
                                                            adicionales
                                                            necesarios para que
                                                            podamos tramitar su
                                                            solicitud. Una vez
                                                            que le hagamos esa
                                                            solicitud, dispondrá
                                                            de diez (10) días
                                                            hábiles, a contar
                                                            desde el día
                                                            siguiente a la
                                                            recepción de nuestra
                                                            solicitud, para
                                                            atenderla. Si no
                                                            responde en ese
                                                            plazo,
                                                            consideraremos que
                                                            su solicitud no se
                                                            ha realizado. Le
                                                            informaremos de
                                                            nuestra decisión en
                                                            un plazo máximo de
                                                            veinte (20) días
                                                            hábiles a partir de
                                                            la fecha en que
                                                            hayamos recibido su
                                                            solicitud inicial.
                                                            En su caso, su
                                                            solicitud surtirá
                                                            efecto en el plazo
                                                            de quince (15) días
                                                            hábiles desde que le
                                                            comuniquemos nuestra
                                                            respuesta.
                                                        </li>
                                                        <li>
                                                            Usted podrá limitar
                                                            el uso o divulgación
                                                            de sus datos
                                                            personales
                                                            poniéndose en
                                                            contacto con Khan
                                                            Academy utilizando
                                                            la información de
                                                            contacto
                                                            proporcionada en el
                                                            aviso de privacidad.
                                                            Los requisitos para
                                                            acreditar su
                                                            identidad, así como
                                                            el procedimiento
                                                            para dar respuesta a
                                                            su solicitud se
                                                            tramitarán de la
                                                            misma manera que se
                                                            describe en el
                                                            párrafo anterior.
                                                        </li>
                                                    </ol>
                                                    <br />

                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        <strong>
                                                            Derechos de los
                                                            menores de edad en
                                                            California
                                                        </strong>
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Si usted es un usuario
                                                        registrado menor de 18
                                                        años con residencia en
                                                        California, tiene
                                                        derecho a solicitar la
                                                        eliminación del
                                                        contenido o los datos
                                                        que haya publicado en
                                                        nuestro Servicio. Para
                                                        solicitar la
                                                        eliminación, diríjase a{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#contact"
                                                        >
                                                            Contacto con Khan
                                                            Academy
                                                        </Link>{" "}
                                                        para obtener ayuda.
                                                        Tenga en cuenta que su
                                                        solicitud no garantiza
                                                        la eliminación completa
                                                        o exhaustiva, ya que el
                                                        contenido o los datos
                                                        pueden conservarse con
                                                        arreglo a la legislación
                                                        aplicable.
                                                    </p>
                                                    <br />
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        <strong>
                                                            Reglamento General
                                                            de Protección de
                                                            Datos ("GDPR", por
                                                            sus siglas en
                                                            inglés)
                                                        </strong>
                                                    </h4>
                                                    <h4
                                                        className={css(
                                                            styles.learnMoreSubheading,
                                                        )}
                                                    >
                                                        Si usted es residente en
                                                        la Unión Europea, el
                                                        Reino Unido u otros
                                                        países que forman parte
                                                        del Espacio Económico
                                                        Europeo, puede tener
                                                        ciertos derechos
                                                        adicionales:
                                                    </h4>
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            <strong>
                                                                Derecho de
                                                                acceso y
                                                                portabilidad.
                                                            </strong>{" "}
                                                            El derecho a obtener
                                                            acceso a sus datos
                                                            personales, junto
                                                            con cierta
                                                            información
                                                            relacionada, y a
                                                            recibir esa
                                                            información en un
                                                            formato de uso común
                                                            y a que se
                                                            transfiera a otro
                                                            responsable del
                                                            tratamiento de datos
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Derecho de
                                                                rectificación.
                                                            </strong>{" "}
                                                            El derecho a obtener
                                                            la rectificación de
                                                            sus datos personales
                                                            sin demora indebida
                                                            cuando esos datos
                                                            personales sean
                                                            inexactos o estén
                                                            incompletos
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Derecho de
                                                                cancelación.
                                                            </strong>{" "}
                                                            El derecho a obtener
                                                            la cancelación de
                                                            sus datos personales
                                                            sin demora indebida
                                                            en determinadas
                                                            circunstancias, como
                                                            cuando los datos
                                                            personales ya no son
                                                            necesarios en
                                                            relación con los
                                                            fines para los que
                                                            fueron recopilados o
                                                            tratados
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Derecho de
                                                                limitación.
                                                            </strong>{" "}
                                                            El derecho a obtener
                                                            la limitación del
                                                            tratamiento
                                                            realizado por
                                                            nosotros sobre sus
                                                            datos personales en
                                                            determinadas
                                                            circunstancias, como
                                                            cuando usted impugna
                                                            la exactitud de los
                                                            datos personales,
                                                            durante un período
                                                            que nos permita
                                                            verificar la
                                                            exactitud de dichos
                                                            datos personales
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Derecho de
                                                                oposición.
                                                            </strong>{" "}
                                                            Derecho a oponerse,
                                                            por motivos
                                                            relacionados con su
                                                            situación
                                                            particular, al
                                                            tratamiento de su
                                                            información
                                                            personal, y a
                                                            oponerse al
                                                            tratamiento de sus
                                                            datos personales con
                                                            fines de
                                                            comercialización
                                                            directa, en la
                                                            medida en que esté
                                                            relacionado con
                                                            dicha
                                                            comercialización
                                                            directa.
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                Derecho a
                                                                retirar el
                                                                consentimiento.
                                                            </strong>{" "}
                                                            El derecho a retirar
                                                            su consentimiento en
                                                            cualquier momento
                                                            (aunque retirar su
                                                            consentimiento no
                                                            afectará la
                                                            legalidad del
                                                            tratamiento que se
                                                            haya realizado antes
                                                            de que retirara su
                                                            consentimiento).
                                                        </li>
                                                    </ul>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        También puede tener
                                                        derecho a presentar una
                                                        reclamación ante la{" "}
                                                        <Link
                                                            target="_blank"
                                                            inline={true}
                                                            href="https://edpb.europa.eu/about-edpb/about-edpb/members_en"
                                                        >
                                                            Autoridad de Control
                                                            correspondiente
                                                        </Link>
                                                        . Si necesita más ayuda
                                                        en relación con sus
                                                        derechos, diríjase a{" "}
                                                        <Link
                                                            inline={true}
                                                            href="#contact"
                                                        >
                                                            contacto a nosotros
                                                        </Link>{" "}
                                                        y estudiaremos su
                                                        solicitud de acuerdo con
                                                        la legislación
                                                        aplicable. En algunos
                                                        casos nuestra capacidad
                                                        para defender estos
                                                        derechos para usted
                                                        puede depender de
                                                        nuestra obligación de
                                                        procesar los datos
                                                        personales por razones
                                                        de seguridad,
                                                        protección, prevención
                                                        del fraude, cumplimiento
                                                        de requisitos
                                                        reglamentarios o
                                                        legales, o porque el
                                                        tratamiento es necesario
                                                        para prestar los
                                                        servicios que usted ha
                                                        solicitado. Cuando este
                                                        sea el caso, le
                                                        informaremos de los
                                                        detalles específicos en
                                                        respuesta a su
                                                        solicitud.
                                                    </p>
                                                    <br />
                                                    <p
                                                        className={css(
                                                            styles.paragraph,
                                                        )}
                                                    >
                                                        Para los datos
                                                        personales sujetos al
                                                        GDPR, nos sustentamos en
                                                        varias bases legales
                                                        para procesar los datos.
                                                        Estas bases legales
                                                        incluyen cuando:
                                                    </p>
                                                    <br />
                                                    <ul
                                                        className={css(
                                                            styles.list,
                                                        )}
                                                    >
                                                        <li>
                                                            El tratamiento es
                                                            necesario para
                                                            cumplir con nuestras
                                                            obligaciones
                                                            contractuales en
                                                            nuestros{" "}
                                                            <Link
                                                                target="_blank"
                                                                inline={true}
                                                                href="/about/docs/khan-academy-terms-of-service"
                                                            >
                                                                Términos de
                                                                Servicio
                                                            </Link>{" "}
                                                            u otros contratos
                                                            con usted
                                                        </li>
                                                        <li>
                                                            El tratamiento es
                                                            necesario para los
                                                            fines de nuestros
                                                            intereses legítimos,
                                                            como en la mejora,
                                                            la personalización y
                                                            el desarrollo del
                                                            Servicio, la
                                                            comercialización del
                                                            Servicio, como
                                                            nuevas
                                                            características o
                                                            productos que pueden
                                                            ser de interés, y la
                                                            promoción de la
                                                            seguridad y la
                                                            protección como se
                                                            describe
                                                            anteriormente
                                                        </li>
                                                        <li>
                                                            Usted nos da su
                                                            consentimiento para
                                                            hacerlo con un
                                                            propósito específico
                                                        </li>
                                                        <li>
                                                            El tratamiento es
                                                            necesario para
                                                            cumplir con una
                                                            obligación legal,
                                                            una orden judicial o
                                                            para ejercer o
                                                            defender
                                                            reclamaciones
                                                            legales
                                                        </li>
                                                    </ul>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </PageRoot>
        );
    }
}

const styles = StyleSheet.create({
    wrapper: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
    },
    header: {
        display: "flex",
        height: 300,
        width: "100vw",
        backgroundPosition: "center",
        backgroundImage: cssUrl("/images/pp_header_desktop.jpg"),
        alignItems: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        [mediaQueries.smOrSmaller]: {
            height: 0,
            paddingTop: "75%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            width: "100vw",
            backgroundImage: cssUrl("/images/pp_header_mobile.jpg"),
        },
    },
    headerCopy: {
        display: "flex",
        flexDirection: "column",
        maxWidth: "55%",
        marginLeft: "5%",
        [mediaQueries.smOrSmaller]: {
            marginTop: "-70%",
            maxWidth: "60%",
            marginLeft: "20%",
            justifyContent: "center",
        },
    },
    pageTitle: {
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
        fontSize: 42,
        fontWeight: 600,
        color: color.darkBlue,
        margin: 0,
        [mediaQueries.smOrSmaller]: {
            fontSize: 35,
            textAlign: "center",
        },
    },
    lastUpdated: {
        fontSize: 18,
        fontStyle: "italic",
        fontWeight: 700,
        lineHeight: "30px",
        color: color.darkBlue,
        margin: 0,
        [mediaQueries.smOrSmaller]: {
            display: "none",
        },
    },
    body: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        padding: "40px 0",
    },
    columns: {
        display: "flex",
        maxWidth: "1200px",
    },
    tableOfContentsColumn: {
        flexDirection: "column",
        fontSize: 18,
        position: "sticky",
        top: 20,
        ...hacks.safariOnly({
            position: "-webkit-sticky",
        }),
        [mediaQueries.smOrSmaller]: {
            display: "none",
        },
    },
    stickyTOC: {
        position: "sticky",
        top: 20,
        marginRight: "8%",
        ...hacks.safariOnly({
            position: "-webkit-sticky",
            alignSelf: "flex-start",
            height: "auto",
        }),
    },
    tocTitle: {
        fontSize: 28,
        lineHeight: "32px",
        color: "#000",
    },
    tableOfContentList: {
        listStyle: "none",
        color: "#1865F2",
        lineHeight: "32px",
        fontSize: 18,
        paddingBottom: 18,
    },
    contentColumn: {
        flex: 2,
        display: "flex",
        flexDirection: "column",
        [mediaQueries.smOrSmaller]: {
            padding: "5%",
        },
    },
    sectionTitle: {
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
        fontSize: 34,
        fontWeight: "normal",
    },
    sectionSubtitle: {
        fontWeight: 700,
        fontSize: 20,
        lineHeight: "32.5px",
    },
    orderedList: {
        listStyleType: "decimal",
        marginLeft: 20,
        lineHeight: "32px",
        fontSize: 18,
        marginBottom: 20,
    },
    list: {
        listStyle: "disc",
        marginLeft: 20,
        lineHeight: "32px",
        fontSize: 18,
        marginBottom: 25,
    },
    subList: {
        listStyle: "circle",
        marginLeft: 25,
        lineHeight: "32px",
        fontSize: 18,
        marginBottom: 0,
    },
    paragraph: {
        fontSize: 18,
        lineHeight: "32px",
        margin: 0,
        marginBottom: 25,
    },
    expandAll: {
        border: 0,
        background: "none",
        textAlign: "right",
        color: "#1865F2",
        float: "right",
        marginBottom: 10,
        cursor: "pointer",
    },
    learnMoreTable: {
        margin: "25px 0",
        width: "100%",
    },
    learnMoreTableContents: {
        backgroundColor: "#F7F8FA",
        transition: `all ${standardTransition}`,
    },
    learnMoreSubheading: {
        fontSize: 20,
        lineHeight: "32px",
    },
    learnMoreTableData: {
        padding: 25,
    },
    learnMoreHeaderContainer: {
        backgroundColor: "#B6D2DA",
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    learnMoreHeader: {
        margin: 0,
        padding: "2%",
        fontFamily: "'Source Serif Pro', 'Noto Serif', serif",
        fontSize: 24,
        fontWeight: "normal",
    },
});
